import React, { useState, useEffect, useRef } from "react";

import { useTranslation } from "react-i18next";

import CreateIdmTickets from "./CreateIdmTickets";
import pillThemeConfig from "styles/pillThemeConfig";
import DataNitivSyncIcon from "components/Common/DataNitivSyncIcon/DataNitivSyncIcon";

import {
  techEquipSolution,
  getdistributionType,
  getRosterConfigByRosterId,
  getRosterTrainee,
  getIdmDetails,
  insertIdmTicket,
  deleteIdmAndFacTicket,
  lockRosterConfig,
  searchEmployeeProfile,
  saveRosterConfigDetails,
  uploadAgentScheduleForRoster,
  updateDataNitivClassId,
  getConfigurationValues,
} from "services/userServices";

import {
  Grid,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Chip,
  Box,
  Paper,
  MenuItem,
  Select,
  FormControl,
  Divider,
  InputAdornment,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CssBaseline,
  Popper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Tooltip,
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";
import Slide from "@mui/material/Slide";
import { GridFooterContainer, GridPagination } from "@mui/x-data-grid";
import { ThemeProvider } from "@mui/material/styles";
import { useNavigate, useLocation } from "react-router-dom";
import {
  theme,
  StyledDataGrid,
  CustomButton,
  AntSwitch,
  useStyles,
  CustomTooltip,
} from "./RosterConfigStyle";

import SearchIcon from "@mui/icons-material/Search";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import NotInterestedOutlinedIcon from "@mui/icons-material/NotInterestedOutlined";
import BlockIcon from "@mui/icons-material/Block";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";

import SnackBar from "components/SnackBar/SnackBar";
import BackdropComponent from "components/Spinner/Spinner";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import PropTypes from "prop-types";
import moment from "moment-timezone";
import { isEqual } from "lodash";
import applicationUsageLog from "utils/applicationUsagesLog";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
} from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format } from "date-fns";
import cssClasses from "../RosterConfig/RosterConfigInputs.module.css";

export const CustomFooter = ({
  displayText,
  pageSize,
  rowCount,
  rowsPerPageLabel,
}) => {
  return (
    <GridFooterContainer>
      <Box sx={{ flex: "1 1 auto" }}>
        <Typography sx={{ fontFamily: "Urbanist, Verdana, Arial, sans-serif" }}>
          &nbsp;&nbsp;&nbsp;
          <b>
            {displayText}&nbsp;{rowCount}
          </b>
        </Typography>
      </Box>
      {rowCount > pageSize && (
        <GridPagination
          sx={{ fontWeight: "bold" }}
          labelRowsPerPage={rowsPerPageLabel}
        />
      )}
    </GridFooterContainer>
  );
};

CustomFooter.propTypes = {
  displayText: PropTypes.string.isRequired,
  pageSize: PropTypes.number.isRequired,
  rowCount: PropTypes.number.isRequired,
  rowsPerPageLabel: PropTypes.string,
};

const sections = [
  { id: "tci", label: "TCI Details", color: pillThemeConfig.OG.primaryColor },
  {
    id: "tciRecovery",
    label: "TCI Recovery",
    color: pillThemeConfig.OG.primaryColor,
  },
  {
    id: "techTest",
    label: "TTD/BOT Details",
    color: pillThemeConfig.OG.primaryColor,
  },
  {
    id: "techTestRecovery",
    label: "TTD/BOT Recovery",
    color: pillThemeConfig.OG.primaryColor,
  },
  { id: "ttf", label: "TTF Details", color: pillThemeConfig.LD.primaryColor },
  {
    id: "productTraining",
    label: "Product Training",
    color: pillThemeConfig.LD.primaryColor,
  },
  {
    id: "nesting",
    label: "Nesting Details",
    color: pillThemeConfig.OPS.primaryColor,
  },
  {
    id: "clientSpecific",
    label: "Client Training",
    color: pillThemeConfig.LD.primaryColor,
  },
];

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const concatenateDateTime = (date, time) => {
  if (!date || !time) return null;
  return (
    moment.utc(date).format("YYYY-MM-DD") +
    "T" +
    moment.utc(time, ["hh:mm:ss a"]).format("HH:mm")
  );
};

const ConfigInputs = ({ type, classRosterId, classRequestId, data }) => {
  const { t } = useTranslation(["newRosterConfig"]);
  const classes = useStyles();

  const [loading, setLoading] = useState([false]);
  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const [focusedField, setFocusedField] = useState(null);

  const [classRosterDetails, setClassRosterDetails] = useState({
    classRosterId: null,
    classRequestId: null,
    isRosterClone: false,
    applyUpdateToAll: false,
    requestedBy: "",
    program: "",
    wave: "",
    modifiedBy: "",
    modfiedDateTime: null,
    rosterLockDateTime: null,
    assignTraineeLockDateTime: null,
    techEquipmentSolutionId: null,
    distributionTypeId: null,
    accDateTime: null,
    accNA: false,
    srwDateTime: null,
    srwDownloadDueNA: false,
    productionStartDate: null,
    rosterNotes: "",
    trainerOracleId: null,
    trainerName: "",
    trainerEmail: "",
    ogOracleId: null,
    ogName: "",
    ogEmail: "",
    askNowTDTId: null,
    askNowTDT: "",
    idmTicketNumber: "",
    fdoOracleId: null,
    fdoName: "",
    fdoEmail: "",

    tciDisplay: false,
    tciNA: false,
    tciDateTime: null,
    tciLocation: "",
    tciMeetingLink: "",
    tciMeetingPassword: "",
    tciPreDate: null,
    tciIsTentative: 2,

    tciRecoveryDisplay: false,
    tciRecoveryNA: false,
    tciRecoveryDateTime: null,
    tciRecoveryLocation: "",
    tciRecoveryMeetingLink: "",
    tciRecoveryMeetingPassword: "",
    tciRecoveryPreDate: null,
    tciRecoveryIsTentative: 2,

    techTestDisplay: false,
    techTestNA: false,
    techTestDateTime: null,
    techTestLocation: "",
    techTestMeetingLink: "",
    techTestMeetingPassword: "",
    techTestPreDate: null,
    techTestIsTentative: 2,

    techTestRecoveryDisplay: false,
    techTestRecoveryNA: false,
    techTestRecoveryDateTime: null,
    techTestRecoveryLocation: "",
    techTestRecoveryMeetingLink: "",
    techTestRecoveryMeetingPassword: "",
    techTestRecoveryPreDate: null,
    techTestRecoveryIsTentative: 2,

    ttfDisplay: false,
    ttfNA: false,
    ttfDateTime: null,
    ttfLocation: "",
    ttfMeetingLink: "",
    ttfMeetingPassword: "",
    ttfHostLink: "",
    ttfPreDate: null,
    ttfIsTentative: 2,

    productTrainingDisplay: false,
    productTrainingNA: false,
    productTrainingDateTime: null,
    productTrainingLocation: "",
    productTrainingMeetingLink: "",
    productTrainingMeetingPassword: "",
    productTrainingPreDate: null,
    productTrainingIsTentative: 0,

    nestingDisplay: false,
    nestingNA: false,
    nestingDateTime: null,
    nestingEndDateTime: null,
    nestingLocation: "",
    nestingMeetingLink: "",
    nestingMeetingPassword: "",
    nestingPreDate: null,
    nestingIsTentative: 2,

    clientSpecificDisplay: false,
    clientSpecificNA: false,
    clientSpecificLocation: "",
    clientSpecificMeetingLink: "",
    clientSpecificMeetingPassword: "",
    clientSpecificHostLink: "",
    clientSpecificPreDate: null,
    clientSpecificIsTentative: 2,
    dataNitivClassReference: "",
    classFillGoal: null,
    productionFillGoalBillable: null,
    productionFillGoalNonBillable: null,
    nestingFillGoal:null,
  });

  const [ttfTrainerData, setTtfTrainerData] = useState([]);

  const prevClassRosterDetails = useRef(null);

  const [showCreateIdmTickets, setShowCreateIdmTickets] = useState(false);

  const handleCreateTicketClick = async () => {
    try {
      if (classRosterDetails) {
        let errorFlag = handleValidateInputs();
        if (errorFlag) {
          if (unsavedChanges) {
            handleDialogOpen(
              async () => {
                setLoading(true);

                const saveRosterConfigData = await saveRosterConfigDetails(
                  classRosterDetails.classRosterId,
                  classRosterDetails.classRequestId,
                  classRosterDetails.isRosterClone,
                  classRosterDetails.applyUpdateToAll,
                  classRosterDetails.requestedBy,
                  classRosterDetails,
                );

                if (saveRosterConfigData.status === true) {
                  setLoading(false);
                  setUnsavedChanges(false);
                  prevClassRosterDetails.current = classRosterDetails;

                  setSnack({
                    open: true,
                    message: t("handleSaveRosterSC01"),
                    severity: "success",
                  });

                  setTimeout(() => {
                    if (generateIdmTicketNew) {
                      navigate("/home/generateidmticket", {
                        state: {
                          classRosterId: classRosterDetails.classRosterId,
                          classRequestId: classRosterDetails.classRequestId,
                          askNowTDT: classRosterDetails.askNowTDT,
                          ttfTrainerData: ttfTrainerData,
                        },
                      });
                    } else setShowCreateIdmTickets(true);
                  }, 2000);
                } else {
                  setLoading(false);
                  setSnack({
                    open: true,
                    message: t("handleSaveRosterER02"),
                    severity: "error",
                  });
                }
              },
              t("unsavedChangeAlertTitle"),
              t("unsavedChangeAlertMsg"),
              [],
              false,
            );
          } else if (generateIdmTicketNew) {
            navigate("/home/generateidmticket", {
              state: {
                classRosterId: classRosterDetails.classRosterId,
                classRequestId: classRosterDetails.classRequestId,
                askNowTDT: classRosterDetails.askNowTDT,
                ttfTrainerData: ttfTrainerData,
              },
            });
          } else {
            setShowCreateIdmTickets(true);
          }
        }
      }
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  };

  const [techEquipSolutionOption, setTechEquipSolutionOption] = useState([]);
  const [distributionTypeOption, setDistributionTypeOption] = useState([]);
  const [disabledSections, setDisabledSections] = React.useState(
    sections.reduce((acc, section) => ({ ...acc, [section.id]: false }), {}),
  );
  const [expandedPanels, setExpandedPanels] = useState(
    sections.reduce((acc, section) => ({ ...acc, [section.id]: true }), {}),
  );
  const [inputValues, setInputValues] = useState(
    sections.reduce(
      (acc, section) => ({
        ...acc,
        [section.id]: {
          display: true,
          NA: false,
          isTentative: 2,
          preDate: null,
          dateTime: null,
          dateTimeError: false,
          endDateTime: null,
          endDateTimeError: false,
          location: "NA",
          meetingLink: "",
          hostLink: "",
          meetingPassword: "",
        },
      }),
      {},
    ),
  );

  const [isProgramExpanded, setIsProgramExpanded] = useState(false);

  const [searchTrainerResults, setSearchTrainerResults] = useState([]);
  const [searchOGResults, setSearchOGResults] = useState([]);
  const [searchFDOResults, setSearchFDOResults] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogAction, setDialogAction] = useState(null);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogBulletList, setDialogBulletList] = useState([]);
  const [isConfirmationDialog, setIsConfirmationDialog] = useState(true);

  const [idmTicketNumber, setIDMTicketNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [traineeRows, setTraineeRows] = useState([]);
  const [ticketRows, setTicketRows] = useState([]);
  const [ticketPageSize, setTicketPageSize] = useState(10);
  const [traineePageSize, setTraineePageSize] = useState(10);
  const [errorACCDateTime, setErrorACCDateTime] = useState(false);
  const [errorSRWDateTime, setErrorSRWDateTime] = useState(false);
  const [errorProductionDate, setErrorProductionDate] = useState(false);
  const [errorWaveNumber, setErrorWaveNumber] = useState(false);
  const [errorNestingStartDate, setErrorNestingStartDate] = useState(false);
  const [errorNestingEndDate, setErrorNestingEndDate] = useState(false);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [errorDataNitivClassRef, setErrorDataNitivClassRef] = useState(false);

  const [isOGAutocompleteOpen, setIsOGAutocompleteOpen] = useState(false);
  const [isFDOAutocompleteOpen, setIsFDOAutocompleteOpen] = useState(false);
  const [isTrainerAutocompleteOpen, setIsTrainerAutocompleteOpen] =
    useState(false);
  const [generateIdmTicketNew, setGenerateIdmTicketNew] = useState(false);

  const totalProdFillGoal =
    (parseFloat(classRosterDetails.productionFillGoalBillable) || 0) +
    (parseFloat(classRosterDetails.productionFillGoalNonBillable) || 0);

  const navigate = useNavigate();

  const traineeColumns = [
    {
      field: "candidateId",
      headerName: t("traineeHeader01"),
      width: 110,
      sortable: true,
    },
    {
      field: "oracleId",
      headerName: t("traineeHeader02"),
      width: 100,
      sortable: true,
    },
    {
      field: "requisitionId",
      headerName: t("traineeHeader03"),
      width: 115,
      sortable: true,
    },
    {
      field: "fullName",
      headerName: t("traineeHeader04"),
      width: 200,
      sortable: true,
      valueGetter: (params) =>
        `${params.row.preferredFirstName || ""} ${
          params.row.preferredLastName || ""
        }`,
    },
    {
      field: "traineeStatus",
      headerName: t("traineeHeader05"),
      width: 150,
      sortable: true,
    },
  ];

  const ticketColumns = [
    {
      field: "idmTicketNumber",
      headerName: t("idmHeader01"),
      width: 100,
      sortable: true,
      renderCell: (params) => {
        const baseUrl =
          window.location.host === "astt.ttec.com"
            ? "https://asknow.service-now.com"
            : "https://asknowdev.service-now.com";

        return (
          <a
            href={`${baseUrl}/sc_req_item.do?sysparm_query=number%3D${params.value}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {params.value}
          </a>
        );
      },
    },
    {
      field: "ticketType",
      headerName: t("idmHeader02"),
      width: 100,
      sortable: true,
    },
    {
      field: "ticketCreateDate",
      headerName: t("idmHeader03"),
      width: 125,
      sortable: true,
    },
    {
      field: "ticketOpenedBy",
      headerName: t("idmHeader04"),
      width: 150,
      sortable: true,
    },
    {
      field: "newClientProgram",
      headerName: t("idmHeader05"),
      width: 150,
      sortable: true,
    },
    {
      field: "facilitiesTicketNumber",
      headerName: t("idmHeader07"),
      width: 160,
      sortable: true,
      renderCell: (params) => {
        const baseUrl =
          window.location.host === "astt.ttec.com"
            ? "https://asknow.service-now.com"
            : "https://asknowdev.service-now.com";
        return params.value ? (
          <a
            href={`${baseUrl}/u_facilities.do?sysparm_query=number%3D${params.value}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {params.value}
          </a>
        ) : null;
      },
    },
    {
      field: "facilitiesTicketCreateDate",
      headerName: t("idmHeader08"),
      width: 130,
      sortable: true,
    },
    {
      field: "delete",
      headerName: t("idmHeader06"),
      width: 80,
      sortable: false,
      renderCell: (params) => (
        <CustomTooltip title={t("toolTipDelete")}>
          <IconButton
            onClick={() =>
              handleDeleteTicket(
                params.row.idmTicketNumber,
                params.row.facilitiesTicketNumber,
              )
            }
          >
            <DeleteIcon />
          </IconButton>
        </CustomTooltip>
      ),
    },
  ];

  const handleDialogOpen = (
    action,
    title,
    message,
    dialogBulletList,
    isConfirmation,
  ) => {
    setDialogAction(() => action);
    setDialogTitle(title || t("dialogTitleDefault"));
    setDialogMessage(message || t("dialogMessageDefault"));
    setDialogBulletList(dialogBulletList || []);
    setIsConfirmationDialog(isConfirmation || false);
    setDialogOpen(true);
  };

  const handleDialogClose = (confirm) => {
    setDialogOpen(false);
    if (confirm && dialogAction) {
      dialogAction();
    }
  };

  const isValidSearch = (input) => {
    const trimmed = input.trim();
    if (/^\d+$/.test(trimmed)) {
      return trimmed.length === 7; // Oracle ID
    } else if (/^[a-zA-Z\s]+$/.test(trimmed)) {
      return trimmed.length >= 3; // Name
    } else if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed)) {
      return true; // Valid Email
    }
    return false;
  };

  const handleTrainerSearch = async (event, searchTrainerQuery) => {
    setLoading(true);
    const trimmedQuery = searchTrainerQuery?.trim();
    if (!trimmedQuery || trimmedQuery.length < 3) {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER01"),
        severity: "error",
      });
      setLoading(false);
      return;
    }

    if (!isValidSearch(trimmedQuery)) {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER03"),
        severity: "error",
      });
      setLoading(false);
      return;
    }

    const searchResult = await searchEmployeeProfile(trimmedQuery);
    if (searchResult.status === true) {
      let searchResultDetails;

      if (/^\d{7}$/.test(trimmedQuery)) {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display:
            (emp.Name ?? "") + (emp.OracleId ? ` (${emp.OracleId})` : ""),
          Name: emp.Name,
          Email: emp.Email,
        }));
      } else {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display: emp.Display,
          Name: emp.Name,
          Email: emp.Email,
        }));
      }

      setSearchTrainerResults(searchResultDetails);

      setSnack({
        open: true,
        message: t("handleOGTrainerSearchSC01"),
        severity: "success",
      });
    } else {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER02"),
        severity: "error",
      });
    }
    setLoading(false);
  };

  const handleTrainerSelect = (event, value) => {
    if (value) {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        trainerOracleId: value.OracleId,
        trainerName: value.Name,
        trainerEmail: value.Email,
      }));
    }
    setSearchTrainerResults([]);
    setIsTrainerAutocompleteOpen(false);
  };

  const handleTrainerInputChange = (event, newInputValue) => {
    if (newInputValue === "") {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        trainerOracleId: null,
        trainerName: "",
        trainerEmail: "",
      }));
      setSearchTrainerResults([]);
    }
  };

  const handleOGSearch = async (event, searchOGQuery) => {
    setLoading(true);
    const trimmedQuery = searchOGQuery?.trim();
    if (!trimmedQuery || trimmedQuery.length < 3) {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER01"),
        severity: "error",
      });
      setLoading(false);
      return;
    }

    if (!isValidSearch(trimmedQuery)) {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER03"),
        severity: "error",
      });
      setLoading(false);
      return;
    }

    const searchResult = await searchEmployeeProfile(trimmedQuery);
    if (searchResult.status === true) {
      let searchResultDetails;

      if (/^\d{7}$/.test(trimmedQuery)) {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display:
            (emp.Name ?? "") + (emp.OracleId ? ` (${emp.OracleId})` : ""),
          Name: emp.Name,
          Email: emp.Email,
        }));
      } else {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display: emp.Display,
          Name: emp.Name,
          Email: emp.Email,
        }));
      }

      setSearchOGResults(searchResultDetails);

      setSnack({
        open: true,
        message: t("handleOGTrainerSearchSC01"),
        severity: "success",
      });
    } else {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER02"),
        severity: "error",
      });
    }
    setLoading(false);
  };

  const handleOGSelect = (event, value) => {
    if (value) {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        ogOracleId: value.OracleId,
        ogName: value.Name,
        ogEmail: value.Email,
      }));
    }
    setSearchOGResults([]);
    setIsOGAutocompleteOpen(false);
  };

  const handleOGInputChange = (event, newInputValue) => {
    if (newInputValue === "") {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        ogOracleId: null,
        ogName: "",
        ogEmail: "",
      }));
      setSearchOGResults([]);
    }
  };

  const handleFDOSearch = async (event, searchFDOQuery) => {
    setLoading(true);
    const trimmedQuery = searchFDOQuery?.trim();
    if (!trimmedQuery || trimmedQuery.length < 3) {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER01"),
        severity: "error",
      });
      setLoading(false);
      return;
    }

    if (!isValidSearch(trimmedQuery)) {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER03"),
        severity: "error",
      });
      setLoading(false);
      return;
    }

    const searchResult = await searchEmployeeProfile(trimmedQuery);
    if (searchResult.status === true) {
      let searchResultDetails;

      if (/^\d{7}$/.test(trimmedQuery)) {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display:
            (emp.Name ?? "") + (emp.OracleId ? ` (${emp.OracleId})` : ""),
          Name: emp.Name,
          Email: emp.Email,
        }));
      } else {
        searchResultDetails = searchResult.data.map((emp) => ({
          OracleId: emp.OracleId,
          Display: emp.Display,
          Name: emp.Name,
          Email: emp.Email,
        }));
      }

      setSearchFDOResults(searchResultDetails);

      setSnack({
        open: true,
        message: t("handleOGTrainerSearchSC01"),
        severity: "success",
      });
    } else {
      setSnack({
        open: true,
        message: t("handleOGTrainerSearchER02"),
        severity: "error",
      });
    }
    setLoading(false);
  };

  const handleFDOSelect = (event, value) => {
    if (value) {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        fdoOracleId: value.OracleId,
        fdoName: value.Name,
        fdoEmail: value.Email,
      }));
    }
    setSearchFDOResults([]);
    setIsFDOAutocompleteOpen(false);
  };

  const handleFDOInputChange = (event, newInputValue) => {
    if (newInputValue === "") {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        fdoOracleId: null,
        fdoName: "",
        fdoEmail: "",
      }));
      setSearchFDOResults([]);
    }
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  function isValidDateTime(value) {
    const dateTimeRegex =
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(\.\d{3})?(Z|[+\\-]\d{2}:\d{2})?$/;
    return dateTimeRegex.test(value);
  }

  function isValidDate(value) {
    const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
    return dateRegex.test(value) && !isNaN(new Date(value).getTime());
  }

  const handleSwitchChange = (event, sectionId) => {
    event.stopPropagation();
    const isChecked = event.target.checked;
    const concatenatedName = `${sectionId}${capitalizeFirstLetter(event.target.name)}`;

    setExpandedPanels((prev) => ({ ...prev, [sectionId]: isChecked }));
    setDisabledSections((prev) => ({ ...prev, [sectionId]: !isChecked }));

    if (isChecked) {
      setInputValues((prevValues) => ({
        ...prevValues,
        [sectionId]: {
          ...prevValues[sectionId],
          NA: false,
          dateTime: classRosterDetails[`${sectionId}DateTime`] ?? null,
          endDateTime: classRosterDetails[`${sectionId}EndDateTime`] ?? null,
          location: classRosterDetails[`${sectionId}Location`] || "NA",
          meetingLink: classRosterDetails[`${sectionId}MeetingLink`] || "",
          meetingPassword:
            classRosterDetails[`${sectionId}MeetingPassword`] || "",
          hostLink: classRosterDetails[`${sectionId}HostLink`] || "",
        },
      }));
    } else {
      setInputValues((prevValues) => ({
        ...prevValues,
        [sectionId]: { ...prevValues[sectionId], NA: true },
      }));
    }

    setClassRosterDetails((prevState) => ({
      ...prevState,
      [concatenatedName]: !isChecked,
    }));
  };

  const handleSummaryClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
  };

  const handleSectionValueChange = (newValue, name, sectionId) => {
    const concatenatedName = `${sectionId}${capitalizeFirstLetter(name)}`;

    let formattedValue = newValue;
    let isError = false;

    if (newValue !== "" && newValue !== null && newValue !== undefined) {
      if (name === "dateTime" || name === "endDateTime") {
        if (isValidDateTime(newValue)) {
          formattedValue = moment(newValue).format("YYYY-MM-DDTHH:mm");
          isError = false;
        } else {
          formattedValue = null;
          isError = true;
        }
      }
    } else {
      formattedValue = null;
      isError = false;
    }

    setInputValues((prevValues) => {
      const newValues = {
        ...prevValues,
        [sectionId]: {
          ...prevValues[sectionId],
          [name]: formattedValue,
          [`${name}Error`]: isError,
        },
      };

      if (
        (sectionId === "ttf" ||
          sectionId === "productTraining" ||
          sectionId === "nesting") &&
        name === "dateTime"
      ) {
        const preDate = prevValues[sectionId][`preDate`];
        if (preDate === null) {
          newValues[sectionId][`isTentative`] = 0;
        } else if (preDate === formattedValue) {
          newValues[sectionId][`isTentative`] = 1;
        } else {
          newValues[sectionId][`isTentative`] = 2;
        }
      }

      return newValues;
    });

    setClassRosterDetails((prevState) => {
      const newState = {
        ...prevState,
        [concatenatedName]: formattedValue,
      };

      if (
        (sectionId === "ttf" ||
          sectionId === "productTraining" ||
          sectionId === "nesting") &&
        name === "dateTime"
      ) {
        const preDate = prevState[`${sectionId}PreDate`];
        if (preDate === null) {
          newState[`${sectionId}IsTentative`] = 0;
        } else if (preDate === formattedValue) {
          newState[`${sectionId}IsTentative`] = 1;
        } else {
          newState[`${sectionId}IsTentative`] = 2;
        }
      }

      return newState;
    });
  };

  const handleClearSection = (sectionId) => {
    if (!disabledSections[sectionId]) {
      setInputValues((prevValues) => ({
        ...prevValues,
        [sectionId]: {
          ...prevValues[sectionId],
          isTentative: 2,
          dateTime: null,
          endDateTime: null,
          location: "NA",
          meetingLink: "",
          hostLink: "",
          meetingPassword: "",
        },
      }));

      setClassRosterDetails((prevState) => ({
        ...prevState,
        [`${sectionId}${capitalizeFirstLetter("isTentative")}`]: 2,
        [`${sectionId}${capitalizeFirstLetter("dateTime")}`]: null,
        [`${sectionId}${capitalizeFirstLetter("endDateTime")}`]: null,
        [`${sectionId}${capitalizeFirstLetter("location")}`]: "NA",
        [`${sectionId}${capitalizeFirstLetter("meetingLink")}`]: "",
        [`${sectionId}${capitalizeFirstLetter("hostLink")}`]: "",
        [`${sectionId}${capitalizeFirstLetter("meetingPassword")}`]: "",
      }));
    }
  };

  const updateSectionData = (sectionId, newValues) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      [sectionId]: {
        ...prevValues[sectionId],
        display: newValues.display,
        NA: newValues.NA,
        isTentative: newValues.isTentative,
        preDate: newValues.preDate,
        dateTime: newValues.NA ? "" : formatDate(newValues.dateTime),
        endDateTime: newValues.NA ? "" : formatDate(newValues.endDateTime),
        location: newValues.NA ? "NA" : newValues.location,
        meetingLink: newValues.NA ? "" : newValues.meetingLink,
        hostLink: newValues.NA ? "" : newValues.hostLink,
        meetingPassword: newValues.NA ? "" : newValues.meetingPassword,
      },
    }));

    if (newValues.hasOwnProperty("NA")) {
      setExpandedPanels((prevPanels) => ({
        ...prevPanels,
        [sectionId]: !newValues.NA,
      }));

      setDisabledSections((prev) => ({
        ...prev,
        [sectionId]: newValues.NA,
      }));
    }
  };

  const isValidPartialInput = (value) => {
    if (value === "") return true;
    if (value === ".") return true;
    const pattern = /^(\d{1,9})?\.?(\d{0,4})?$/;
    return pattern.test(value);
  };

  // Extract validation and formatting logic
  const formatDateTime = (value, setError) => {
    if (!value) {
      setError(false);
      return null;
    }

    if (isValidDateTime(value)) {
      setError(false);
      return moment(value).format("YYYY-MM-DDTHH:mm");
    }

    setError(true);
    return null;
  };

  const formatProductionDate = (value, setError) => {
    if (!value) {
      setError(true);
      return null;
    }

    if (isValidDate(value)) {
      setError(false);
      return moment(value).format("YYYY-MM-DD");
    }

    setError(true);
    return null;
  };

  const validateAndFormatWave = (value, setError, setClassRosterDetails) => {
    const normalizedValue = value.replace(",", ".");

    if (normalizedValue === "" || isValidPartialInput(normalizedValue)) {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        wave: normalizedValue,
      }));
    }

    setError(normalizedValue !== "" && !validateWaveNumber(normalizedValue));
  };

  // Extract DataNitiv logic
  const handleDataNitivUpdate = async (
    value,
    classRosterId,
    currentValue,
    setError,
    setSnack,
    t,
  ) => {
    if (value.length === 0 && currentValue !== null) {
      return await updateDataNitivClassEmpty(
        classRosterId,
        setError,
        setSnack,
        t,
      );
    }

    if (value.length === 13) {
      return await updateDataNitivClassWithValue(
        value,
        classRosterId,
        setError,
        setSnack,
        t,
      );
    }

    return value;
  };

  const updateDataNitivClassEmpty = async (
    classRosterId,
    setError,
    setSnack,
    t,
  ) => {
    const updateResult = await updateDataNitivClassId(classRosterId, "");

    if (updateResult.data[0].IsError === 0) {
      setError(false);
      setSnack({
        open: true,
        message: t("rosterdataNitivSuccess"),
        severity: "success",
      });
      return "";
    }

    return null;
  };

  const updateDataNitivClassWithValue = async (
    value,
    classRosterId,
    setError,
    setSnack,
    t,
  ) => {
    const formattedValue = value.replace(/,/g, "_").toUpperCase();
    const isValid = /^TC_\d{4}_\d{5}$/.test(formattedValue);

    if (!isValid) {
      setError(true);
      setSnack({
        open: true,
        message: t("rosterdataNitivError"),
        severity: "error",
      });
      return null;
    }

    const updateResult = await updateDataNitivClassId(
      classRosterId,
      formattedValue,
    );

    if (updateResult.data[0].IsError === 0) {
      setError(false);
      setSnack({
        open: true,
        message: t("rosterdataNitivSuccess"),
        severity: "success",
      });
      return formattedValue;
    }

    setError(true);
    setSnack({
      open: true,
      message: updateResult.data[0].Message,
      severity: "error",
    });
    return null;
  };

  const HIDE_TCI_IDS = [1, 2, 3, 4];

  const HIDE_TTD_BOT_IDS = [5, 6, 7, 8, 15, 16, 17, 18, 23, 24, 25, 26];

  const SRW_NA_IDS = [3, 4];

  // Extract tech equipment logic
  const handleTechEquipmentUpdate = (
    value,
    handleDialogOpen,
    setInputValues,
    setClassRosterDetails,
    t,
  ) => {
    const hideTCI = HIDE_TCI_IDS.includes(value);
    const hideTTDBOT = HIDE_TTD_BOT_IDS.includes(value);
    const autoSRW = SRW_NA_IDS.includes(value);
    const requiresDialog = hideTCI || hideTTDBOT;

    const applySRWNA = (shouldBeNA) => {
      setClassRosterDetails((prevState) => ({
        ...prevState,
        srwDownloadDueNA: shouldBeNA,
        srwDateTime: shouldBeNA ? null : prevState.srwDateTime,
      }));
    };

    if (!requiresDialog) {
      updateAllTechInputs(setInputValues);
      updateClassRosterState(
        setClassRosterDetails,
        "techEquipmentSolutionId",
        value,
      );
      applySRWNA(autoSRW);
      return;
    }

    const disabledSections = hideTTDBOT
      ? [t("techTest"), t("techTestRecovery")]
      : [t("tci"), t("tciRecovery")];

    handleDialogOpen(
      () => {
        updateTechInputsByValue(value, setInputValues);
        updateClassRosterState(
          setClassRosterDetails,
          "techEquipmentSolutionId",
          value,
        );
        applySRWNA(autoSRW);
      },
      t("techEquipmentSolution"),
      t("dialogMessageTechSolution"),
      disabledSections,
      false,
    );
  };

  const updateTechInputsByValue = (value, setInputValues) => {
    const showTci = !HIDE_TCI_IDS.includes(value);
    const showTTDBOT = !HIDE_TTD_BOT_IDS.includes(value);

    setInputValues((prevValues) => ({
      ...prevValues,
      tci: { ...prevValues["tci"], display: showTci, NA: !showTci },
      tciRecovery: {
        ...prevValues["tciRecovery"],
        display: showTci,
        NA: !showTci,
      },
      techTest: {
        ...prevValues["techTest"],
        display: showTTDBOT,
        NA: !showTTDBOT,
      },
      techTestRecovery: {
        ...prevValues["techTestRecovery"],
        display: showTTDBOT,
        NA: !showTTDBOT,
      },
    }));

    setClassRosterDetails((prevState) => ({
      ...prevState,
      tciDisplay: showTci,
      tciNA: !showTci,
      tciRecoveryDisplay: showTci,
      tciRecoveryNA: !showTci,
      techTestDisplay: showTTDBOT,
      techTestNA: !showTTDBOT,
      techTestRecoveryDisplay: showTTDBOT,
      techTestRecoveryNA: !showTTDBOT,
    }));

    setExpandedPanels((prev) => ({
      ...prev,
      tci: showTci,
      tciRecovery: showTci,
      techTest: showTTDBOT,
      techTestRecovery: showTTDBOT,
    }));

    setDisabledSections((prev) => ({
      ...prev,
      tci: !showTci,
      tciRecovery: !showTci,
      techTest: !showTTDBOT,
      techTestRecovery: !showTTDBOT,
    }));
  };
  const updateAllTechInputs = (setInputValues) => {
    setInputValues((prevValues) => ({
      ...prevValues,
      tci: { ...prevValues["tci"], display: true, NA: false },
      tciRecovery: { ...prevValues["tciRecovery"], display: true, NA: false },
      techTest: { ...prevValues["techTest"], display: true, NA: false },
      techTestRecovery: {
        ...prevValues["techTestRecovery"],
        display: true,
        NA: false,
      },
    }));

    setClassRosterDetails((prevState) => ({
      ...prevState,
      tciDisplay: true,
      tciNA: false,
      tciRecoveryDisplay: true,
      tciRecoveryNA: false,
      techTestDisplay: true,
      techTestNA: false,
      techTestRecoveryDisplay: true,
      techTestRecoveryNA: false,
    }));

    setExpandedPanels((prev) => ({
      ...prev,
      tci: true,
      tciRecovery: true,
      techTest: true,
      techTestRecovery: true,
    }));

    setDisabledSections((prev) => ({
      ...prev,
      tci: false,
      tciRecovery: false,
      techTest: false,
      techTestRecovery: false,
    }));
  };

  const updateClassRosterState = (setClassRosterDetails, ctrlName, value) => {
    setClassRosterDetails((prevState) => ({
      ...prevState,
      [ctrlName]: value,
    }));
  };

  // Main handler - simplified
  const handleValueChange = async (ctrlName, ctrlValue) => {
    let formattedValue = ctrlValue;

    // Handle datetime fields
    if (ctrlName === "accDateTime") {
      formattedValue = formatDateTime(ctrlValue, setErrorACCDateTime);
    } else if (ctrlName === "srwDateTime") {
      formattedValue = formatDateTime(ctrlValue, setErrorSRWDateTime);
    } else if (ctrlName === "productionStartDate") {
      formattedValue = formatProductionDate(ctrlValue, setErrorProductionDate);
    }

    // Handle wave number
    if (ctrlName === "wave") {
      validateAndFormatWave(
        ctrlValue,
        setErrorWaveNumber,
        setClassRosterDetails,
      );
      return;
    }

    // Handle DataNitiv class reference
    if (ctrlName === "dataNitivClassReference") {
      const result = await handleDataNitivUpdate(
        ctrlValue,
        classRosterId,
        classRosterDetails.dataNitivClassReference,
        setErrorDataNitivClassRef,
        setSnack,
        t,
      );

      if (result !== null) {
        updateClassRosterState(setClassRosterDetails, ctrlName, result);
      }
      setLoading(false);
      return;
    }

    // Handle tech equipment solution
    if (ctrlName === "techEquipmentSolutionId") {
      handleTechEquipmentUpdate(
        formattedValue,
        handleDialogOpen,
        setInputValues,
        setClassRosterDetails,
        t,
      );
      return;
    }

    // Default state update
    updateClassRosterState(setClassRosterDetails, ctrlName, formattedValue);
  };

  // Extract key code constants
  const ALLOWED_SPECIAL_KEYS = [46, 8, 9, 27, 13]; // Delete, Backspace, Tab, Escape, Enter
  const CTRL_KEY_CODES = {
    SELECT_ALL: 65,
    COPY: 67,
    CUT: 88,
    PASTE: 86,
  };
  const NAVIGATION_KEYS = { START: 35, END: 39 };
  const NUMBER_KEYS = { START: 48, END: 57 };
  const NUMPAD_KEYS = { START: 96, END: 105 };
  const DECIMAL_KEYS = [190, 110]; // Period and numpad decimal

  // Helper functions
  const isSpecialKey = (keyCode) => ALLOWED_SPECIAL_KEYS.includes(keyCode);

  const isCtrlCombination = (event) => {
    return (
      event.ctrlKey && Object.values(CTRL_KEY_CODES).includes(event.keyCode)
    );
  };

  const isNavigationKey = (keyCode) => {
    return keyCode >= NAVIGATION_KEYS.START && keyCode <= NAVIGATION_KEYS.END;
  };

  const shouldAllowKey = (event) => {
    return (
      isSpecialKey(event.keyCode) ||
      isCtrlCombination(event) ||
      isNavigationKey(event.keyCode)
    );
  };

  const handleArrowKeyPress = (event, setClassRosterDetails) => {
    event.preventDefault();

    const currentValue = event.target.value;
    const numValue = parseFloat(currentValue) || 0;
    const decimals = getDecimalPlaces(currentValue);
    const step = Math.pow(10, -(decimals || 1));

    const newValue = calculateNewValue(numValue, step, event.key);
    const formatted = newValue.toFixed(decimals);

    setClassRosterDetails((prevState) => ({
      ...prevState,
      wave: formatted,
    }));
  };

  const getDecimalPlaces = (value) => {
    return value.includes(".") ? value.split(".")[1].length : 0;
  };

  const calculateNewValue = (value, step, key) => {
    let newValue = value + (key === "ArrowUp" ? step : -step);

    if (newValue < 0) return 0;
    if (newValue > 999999999.9999) return 999999999.9999;

    return newValue;
  };

  const isValidNumberKey = (event) => {
    const keyCode = event.keyCode;
    const isNumberKey =
      keyCode >= NUMBER_KEYS.START && keyCode <= NUMBER_KEYS.END;
    const isNumpadKey =
      keyCode >= NUMPAD_KEYS.START && keyCode <= NUMPAD_KEYS.END;
    const isDecimalKey = DECIMAL_KEYS.includes(keyCode);

    return !event.shiftKey && (isNumberKey || isNumpadKey || isDecimalKey);
  };

  const hasMaxDecimalPlaces = (value, maxDecimals = 4) => {
    const decimalPart = value.split(".")[1];
    return decimalPart && decimalPart.length >= maxDecimals;
  };

  const shouldPreventNumberInput = (event, currentValue) => {
    const keyCode = event.keyCode;
    const isNumberKey =
      (keyCode >= NUMBER_KEYS.START && keyCode <= NUMBER_KEYS.END) ||
      (keyCode >= NUMPAD_KEYS.START && keyCode <= NUMPAD_KEYS.END);

    return isNumberKey && hasMaxDecimalPlaces(currentValue);
  };

  // Main handler - simplified
  const handleKeyDown = (event) => {
    // Allow special keys and shortcuts
    if (shouldAllowKey(event)) {
      return;
    }

    // Handle arrow up/down for incrementing/decrementing
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      handleArrowKeyPress(event, setClassRosterDetails);
      return;
    }

    // Block invalid keys
    if (!isValidNumberKey(event)) {
      event.preventDefault();
      return;
    }

    // Prevent exceeding 4 decimal places
    const currentValue = event.target.value;
    if (shouldPreventNumberInput(event, currentValue)) {
      event.preventDefault();
    }
  };

  const validateWaveNumber = (value) => {
    if (value === "" || value === ".") return false;
    const numberPattern = /^\d{1,9}(\.\d{1,4})?$/;
    if (!numberPattern.test(value)) return false;
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return false;
    if (numValue < 0 || numValue > 999999999.9999) return false;
    return true;
  };

  const formatWaveNumber = (value) => {
    if (value === "") {
      setErrorWaveNumber(true);
      return;
    }
    const strValue = value.toString();

    if (!validateWaveNumber(strValue)) {
      setErrorWaveNumber(true);
      return;
    }

    if (!strValue.includes(".")) {
      const formatted = strValue + ".00";
      setClassRosterDetails((prevState) => ({
        ...prevState,
        wave: formatted,
      }));
      setErrorWaveNumber(false);
      return;
    }

    setClassRosterDetails((prevState) => ({ ...prevState, wave: strValue }));
    setErrorWaveNumber(false);
  };

  const getStepValue = (value) => {
    const s = value == null ? "" : String(value);
    if (!s.includes(".")) return "1";
    const decimals = (s.split(".")[1] || "").length;
    if (decimals <= 0) return "1";
    const capped = Math.min(decimals, 4);
    return (1 / Math.pow(10, capped)).toFixed(capped);
  };

  const formatDate = (date) => {
    return date ? moment.utc(date).format("YYYY-MM-DDTHH:mm") : null;
  };

  const fetchTechEquipmentSolutions = async (techEquipmentSolutionId) => {
    const techEquipSol = await techEquipSolution();
    if (techEquipSol.status === true) {
      if (techEquipmentSolutionId !== 2) {
        setTechEquipSolutionOption(
          techEquipSol.data.filter(
            (item) => item.TechEquipmentSolutionId !== 2,
          ),
        );
      } else {
        setTechEquipSolutionOption(techEquipSol.data);
      }
    } else {
      setSnack({
        open: true,
        message: t("fetchTechEquipmentER01"),
        severity: "error",
      });
    }
  };

  const fetchDistributionTypes = async () => {
    const distributionType = await getdistributionType();
    if (distributionType.status === true) {
      setDistributionTypeOption(distributionType.data);
    } else {
      setSnack({
        open: true,
        message: t("fetchDistributionER01"),
        severity: "error",
      });
    }
  };

  async function fetchTicketsAndTrainees(classRosterId) {
    try {
      setTicketRows([]);
      setTraineeRows([]);

      const idmTicketDetails = await getIdmDetails(classRosterId);

      if (idmTicketDetails.status === true) {
        const idmTicketData = idmTicketDetails.data.map((idmTicket) => ({
          id: idmTicket.idmTicketNumber,
          idmTicketNumber: idmTicket.idmTicketNumber,
          ticketType: idmTicket.ticketType,
          ticketCreateDate: idmTicket.ticketCreateDate,
          ticketOpenedBy: idmTicket.ticketOpenedBy,
          newClientProgram: idmTicket.newClientProgram,
          facilitiesTicketNumber: idmTicket.facilitiesTicketNumber,
          facilitiesTicketCreateDate: idmTicket.facilitiesTicketCreateDate,
        }));

        setTicketRows(idmTicketData);
      }

      const classTraineeDetails = await getRosterTrainee(classRosterId);

      if (classTraineeDetails.status === true) {
        const classTraineeData = classTraineeDetails.data.map((trainee) => ({
          id: trainee.classTraineeId,
          candidateId: trainee.candidateId,
          oracleId: trainee.oracleId,
          requisitionId: trainee.requisitionId,
          preferredFirstName: trainee.preferredFirstName,
          preferredLastName: trainee.preferredLastName,
          traineeStatus: trainee.traineeStatus,
        }));

        setTraineeRows(classTraineeData);
      }
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  }

  // Helper functions for data transformation
  const formatDateIfExists = (date) => (date ? formatDate(date) : null);

  const concatenateDateTimeIfExists = (date, time) => {
    return date ? concatenateDateTime(date, time) : null;
  };

  const getValueOrNull = (value) => (value !== undefined ? value : null);

  const getValueOrEmpty = (value) => value || "";

  const getValueOrDefault = (value, defaultValue = "NA") =>
    value || defaultValue;

  // Extract metadata mapping
  const mapRosterMetadata = (
    classRosterData,
    classRosterId,
    classRequestId,
    isClone,
  ) => ({
    classRosterId: classRosterId || null,
    classRequestId: classRequestId || null,
    isRosterClone: isClone,
    applyUpdateToAll: false,
    requestedBy: localStorage.getItem("User") || "",
    alreadyAssignedWaves: classRosterData.AlreadyAssignedWaves,
    program: getValueOrEmpty(classRosterData.ProgramName),
    wave: getValueOrEmpty(classRosterData.Wave),
    modifiedBy: getValueOrEmpty(classRosterData.ModifiedBy),
    modfiedDateTime: formatDateIfExists(classRosterData.ModifiedDate),
    rosterLockDateTime: formatDateIfExists(classRosterData.RosterLockDate),
    assignTraineeLockDateTime: formatDateIfExists(
      classRosterData.AssignTraineesLockTimestamp,
    ),
  });

  // Extract basic config mapping
  const mapBasicConfig = (classRosterData) => ({
    techEquipmentSolutionId: getValueOrNull(
      classRosterData.TechEquipmentSolutionId,
    ),
    distributionTypeId: getValueOrNull(classRosterData.DistributionTypeId),
    accDateTime: concatenateDateTimeIfExists(
      classRosterData.ACCDate,
      classRosterData.ACCTime,
    ),
    accNA: classRosterData.ACCNA,
    srwDateTime: concatenateDateTimeIfExists(
      classRosterData.SRWDownloadDueDate,
      classRosterData.SRWDownloadDueTime,
    ),
    srwDownloadDueNA: classRosterData.SRWDownloadDueNA,
    productionStartDate: classRosterData.ProductionDate
      ? moment.utc(classRosterData.ProductionDate).format("YYYY-MM-DD")
      : null,
    rosterNotes: getValueOrEmpty(classRosterData.RosterNotes),
    idmTicketNumber: getValueOrEmpty(classRosterData.IDMTicketNumber),
    dataNitivClassReference: getValueOrEmpty(
      classRosterData.DataNitivClassReference,
    ),
    classFillGoal: classRosterData.ClassFillGoal ?? null,
    productionFillGoalBillable:
      classRosterData.ProductionFillGoalBillable ?? null,
    productionFillGoalNonBillable:
      classRosterData.ProductionFillGoalNonBillable ?? null,
    nestingFillGoal: classRosterData.NestingFillGoal ?? null,  
  });

  // Extract personnel mapping
  const mapPersonnel = (classRosterData) => ({
    trainerOracleId: getValueOrNull(classRosterData.TrainerOracleId),
    trainerName:
      classRosterData.TrainerName !== undefined
        ? classRosterData.TrainerName
        : "",
    trainerEmail: getValueOrEmpty(classRosterData.TrainerEmail),
    ogOracleId: getValueOrNull(classRosterData.OGOracleId),
    ogName: classRosterData.OGName !== undefined ? classRosterData.OGName : "",
    ogEmail: getValueOrEmpty(classRosterData.OGEmail),
    fdoOracleId: getValueOrNull(classRosterData.FDOOracleId),
    fdoName:
      classRosterData.FDOName !== undefined ? classRosterData.FDOName : "",
    fdoEmail: getValueOrEmpty(classRosterData.FDOEmail),
    askNowTDTId: classRosterData.AskNowTDTId || null,
    askNowTDT: getValueOrEmpty(classRosterData.AskNowTDT),
  });

  // Generic section mapper for similar structures
  const mapBasicSection = (prefix, data) => ({
    [`${prefix}Display`]: data[`${prefix}Display`],
    [`${prefix}NA`]: data[`${prefix}NA`],
    [`${prefix}DateTime`]: concatenateDateTimeIfExists(
      data[`${prefix}Date`],
      data[`${prefix}Time`],
    ),
    [`${prefix}Location`]: getValueOrEmpty(data[`${prefix}Location`]),
    [`${prefix}MeetingLink`]: getValueOrEmpty(data[`${prefix}ZoomLink`]),
    [`${prefix}MeetingPassword`]: getValueOrEmpty(
      data[`${prefix}ZoomPassword`],
    ),
    [`${prefix}PreDate`]: null,
    [`${prefix}IsTentative`]: 2,
  });

  // Map TCI section
  const mapTCISection = (classRosterData) => ({
    ...mapBasicSection("tci", {
      tciDisplay: classRosterData.TCIDisplay,
      tciNA: classRosterData.TCINA,
      tciDate: classRosterData.TCIDate,
      tciTime: classRosterData.TCITime,
      tciLocation: classRosterData.TCILocation,
      tciZoomLink: classRosterData.TCIZoomLink,
      tciZoomPassword: classRosterData.TCIZoomPassword,
    }),
  });

  // Map TCI Recovery section
  const mapTCIRecoverySection = (classRosterData) => ({
    ...mapBasicSection("tciRecovery", {
      tciRecoveryDisplay: classRosterData.TCIRecoveryDisplay,
      tciRecoveryNA: classRosterData.TCIRecoveryNA,
      tciRecoveryDate: classRosterData.TCIRecoveryDate,
      tciRecoveryTime: classRosterData.TCIRecoveryTime,
      tciRecoveryLocation: classRosterData.TCIRecoveryLocation,
      tciRecoveryZoomLink: classRosterData.TCIRecoveryZoomLink,
      tciRecoveryZoomPassword: classRosterData.TCIRecoveryZoomPassword,
    }),
  });

  // Map Tech Test section
  const mapTechTestSection = (classRosterData) => ({
    ...mapBasicSection("techTest", {
      techTestDisplay: classRosterData.TechTestDisplay,
      techTestNA: classRosterData.TechTestNA,
      techTestDate: classRosterData.TechTestDate,
      techTestTime: classRosterData.TechTestTime,
      techTestLocation: classRosterData.TechTestLocation,
      techTestZoomLink: classRosterData.TechTestZoomLink,
      techTestZoomPassword: classRosterData.TechTestZoomPassword,
    }),
  });

  // Map Tech Test Recovery section
  const mapTechTestRecoverySection = (classRosterData) => ({
    ...mapBasicSection("techTestRecovery", {
      techTestRecoveryDisplay: classRosterData.TechTestRecoveryDisplay,
      techTestRecoveryNA: classRosterData.TechTestRecoveryNA,
      techTestRecoveryDate: classRosterData.TechTestRecoveryDate,
      techTestRecoveryTime: classRosterData.TechTestRecoveryTime,
      techTestRecoveryLocation: classRosterData.TechTestRecoveryLocation,
      techTestRecoveryZoomLink: classRosterData.TechTestRecoveryZoomLink,
      techTestRecoveryZoomPassword:
        classRosterData.TechTestRecoveryZoomPassword,
    }),
  });

  // Map TTF section (with host link)
  const mapTTFSection = (classRosterData) => ({
    ttfDisplay: classRosterData.TTFDisplay,
    ttfNA: classRosterData.TTFNA,
    ttfDateTime: concatenateDateTimeIfExists(
      classRosterData.TTFDate,
      classRosterData.TTFTime,
    ),
    ttfLocation: getValueOrEmpty(classRosterData.TTFLocation),
    ttfMeetingLink: getValueOrEmpty(classRosterData.TTFZoomLink),
    ttfMeetingPassword: getValueOrEmpty(classRosterData.TTFZoomPassword),
    ttfHostLink: getValueOrEmpty(classRosterData.TTFZoomHostKey),
    ttfPreDate: classRosterData.PreTTFDate || null,
    ttfIsTentative: classRosterData.IsTentativeTTFDate || 2,
  });

  // Map Product Training section
  const mapProductTrainingSection = (classRosterData) => ({
    productTrainingDisplay: classRosterData.ProductTrainingDisplay,
    productTrainingNA: classRosterData.ProductTrainingNA,
    productTrainingDateTime: concatenateDateTimeIfExists(
      classRosterData.ProductTrainingDate,
      classRosterData.ProductTrainingTime,
    ),
    productTrainingLocation: getValueOrEmpty(
      classRosterData.ProductTrainingLocation,
    ),
    productTrainingMeetingLink: getValueOrEmpty(
      classRosterData.ProductTrainingZoomLink,
    ),
    productTrainingMeetingPassword: getValueOrEmpty(
      classRosterData.ProductTrainingZoomPassword,
    ),
    productTrainingPreDate: classRosterData.PreProductTrainingDate || null,
    productTrainingIsTentative:
      classRosterData.IsTentativeProductTrainingDate || 0,
  });

  // Map Nesting section (with end date)
  const mapNestingSection = (classRosterData) => ({
    nestingDisplay: classRosterData.NestingDisplay,
    nestingNA: classRosterData.NestingNA,
    nestingDateTime: concatenateDateTimeIfExists(
      classRosterData.NestingStartDate,
      classRosterData.NestingStartTime,
    ),
    nestingEndDateTime: concatenateDateTimeIfExists(
      classRosterData.NestingEndDate,
      classRosterData.NestingEndTime,
    ),
    nestingLocation: getValueOrEmpty(classRosterData.NestingLocation),
    nestingMeetingLink: getValueOrEmpty(classRosterData.NestingZoomLink),
    nestingMeetingPassword: getValueOrEmpty(
      classRosterData.NestingZoomPassword,
    ),
    nestingPreDate: classRosterData.PreNestingDate || null,
    nestingIsTentative: classRosterData.IsTentativeNestingDate || 2,
  });

  // Map Client Specific section
  const mapClientSpecificSection = (classRosterData) => ({
    clientSpecificDisplay: classRosterData.ClientSpecificDisplay,
    clientSpecificNA: classRosterData.ClientSpecificNA,
    clientSpecificLocation: getValueOrEmpty(
      classRosterData.ClientSpecificLocation,
    ),
    clientSpecificMeetingLink: getValueOrEmpty(
      classRosterData.ClientSpecificZoomLink,
    ),
    clientSpecificMeetingPassword: getValueOrEmpty(
      classRosterData.ClientSpecificZoomPassword,
    ),
    clientSpecificHostLink: getValueOrEmpty(
      classRosterData.ClientSpecificZoomHostKey,
    ),
    clientSpecificPreDate: null,
    clientSpecificIsTentative: 2,
  });

  // Combine all mappings
  const mapClassRosterDetails = (
    classRosterData,
    classRosterId,
    classRequestId,
    isClone,
  ) => ({
    ...mapRosterMetadata(
      classRosterData,
      classRosterId,
      classRequestId,
      isClone,
    ),
    ...mapBasicConfig(classRosterData),
    ...mapPersonnel(classRosterData),
    ...mapTCISection(classRosterData),
    ...mapTCIRecoverySection(classRosterData),
    ...mapTechTestSection(classRosterData),
    ...mapTechTestRecoverySection(classRosterData),
    ...mapTTFSection(classRosterData),
    ...mapProductTrainingSection(classRosterData),
    ...mapNestingSection(classRosterData),
    ...mapClientSpecificSection(classRosterData),
  });

  // Helper to create section data object
  const createSectionData = (data, prefix) => ({
    display: data[`${prefix}Display`],
    NA: data[`${prefix}NA`],
    isTentative: data[`IsTentative${prefix}Date`] || 2,
    preDate: data[`Pre${prefix}Date`] || null,
    dateTime: concatenateDateTimeIfExists(
      data[`${prefix}Date`],
      data[`${prefix}Time`],
    ),
    location: getValueOrDefault(data[`${prefix}Location`]),
    meetingLink: getValueOrEmpty(data[`${prefix}ZoomLink`]),
    meetingPassword: getValueOrEmpty(data[`${prefix}ZoomPassword`]),
    ...(data[`${prefix}ZoomHostKey`] && {
      hostLink: data[`${prefix}ZoomHostKey`],
    }),
  });

  // Helper for sections with end date
  const createNestingSectionData = (data) => ({
    display: data.NestingDisplay,
    NA: data.NestingNA,
    isTentative: data.IsTentativeNestingDate || 2,
    preDate: data.PreNestingDate || null,
    dateTime: concatenateDateTimeIfExists(
      data.NestingStartDate,
      data.NestingStartTime,
    ),
    endDateTime: concatenateDateTimeIfExists(
      data.NestingEndDate,
      data.NestingEndTime,
    ),
    location: getValueOrDefault(data.NestingLocation),
    meetingLink: getValueOrEmpty(data.NestingZoomLink),
    meetingPassword: getValueOrEmpty(data.NestingZoomPassword),
  });

  // Update all input values
  const updateAllSectionData = (classRosterData, updateSectionData) => {
    const sections = [
      { key: "tci", prefix: "TCI" },
      { key: "tciRecovery", prefix: "TCIRecovery" },
      { key: "techTest", prefix: "TechTest" },
      { key: "techTestRecovery", prefix: "TechTestRecovery" },
      { key: "ttf", prefix: "TTF" },
      { key: "productTraining", prefix: "ProductTraining" },
    ];

    sections.forEach(({ key, prefix }) => {
      updateSectionData(key, createSectionData(classRosterData, prefix));
    });

    // Handle nesting separately (has endDateTime)
    updateSectionData("nesting", createNestingSectionData(classRosterData));

    // Handle client specific (no dateTime)
    updateSectionData("clientSpecific", {
      display: classRosterData.ClientSpecificDisplay,
      NA: classRosterData.ClientSpecificNA,
      isTentative: 2,
      preDate: null,
      location: getValueOrDefault(classRosterData.ClientSpecificLocation),
      meetingLink: getValueOrEmpty(classRosterData.ClientSpecificZoomLink),
      hostLink: getValueOrEmpty(classRosterData.ClientSpecificZoomHostKey),
      meetingPassword: getValueOrEmpty(
        classRosterData.ClientSpecificZoomPassword,
      ),
    });
  };

  // Simplified main function
  async function fetchRosterConfigData(classRosterId, data) {
    try {
      const configRosterDetails = await getRosterConfigByRosterId(
        classRosterId,
        data,
      );

      if (!configRosterDetails.status) {
        setSnack({
          open: true,
          message: t("fetchRosterConfigER01"),
          severity: "error",
        });
        return;
      }

      const classRosterData = configRosterDetails.data[0];

      if (!classRosterData) {
        return;
      }

      const isClone = data === "true";

      const mappedDetails = mapClassRosterDetails(
        classRosterData,
        classRosterId,
        classRequestId,
        isClone,
      );

      setClassRosterDetails(mappedDetails);

      prevClassRosterDetails.current = mappedDetails;

      updateAllSectionData(classRosterData, updateSectionData);

      const techId = mappedDetails.techEquipmentSolutionId;
      if (techId) {
        const showTci = !HIDE_TCI_IDS.includes(techId);
        const showTTDBOT = !HIDE_TTD_BOT_IDS.includes(techId);

        // Read the DB-persisted NA flags that updateAllSectionData just set
        // via updateSectionData. Because setState is async we capture them
        // from mappedDetails (the freshly mapped DB values) so they are
        // available synchronously for all three set calls below.
        const dbTciNA = mappedDetails.tciNA;
        const dbTciRecoveryNA = mappedDetails.tciRecoveryNA;
        const dbTechTestNA = mappedDetails.techTestNA;
        const dbTechTestRecoveryNA = mappedDetails.techTestRecoveryNA;

        // A section is NA when the dropdown forces it hidden OR the user had
        // already marked it NA in the DB.
        const tciNA = !showTci || dbTciNA;
        const tciRecoveryNA = !showTci || dbTciRecoveryNA;
        const techTestNA = !showTTDBOT || dbTechTestNA;
        const techTestRecoveryNA = !showTTDBOT || dbTechTestRecoveryNA;

        setInputValues((prevValues) => ({
          ...prevValues,
          tci: { ...prevValues["tci"], display: showTci, NA: tciNA },
          tciRecovery: {
            ...prevValues["tciRecovery"],
            display: showTci,
            NA: tciRecoveryNA,
          },
          techTest: {
            ...prevValues["techTest"],
            display: showTTDBOT,
            NA: techTestNA,
          },
          techTestRecovery: {
            ...prevValues["techTestRecovery"],
            display: showTTDBOT,
            NA: techTestRecoveryNA,
          },
        }));

        // Collapsed (expanded=false, disabled=true) when NA, expanded when active.
        setExpandedPanels((prev) => ({
          ...prev,
          tci: !tciNA,
          tciRecovery: !tciRecoveryNA,
          techTest: !techTestNA,
          techTestRecovery: !techTestRecoveryNA,
        }));

        setDisabledSections((prev) => ({
          ...prev,
          tci: tciNA,
          tciRecovery: tciRecoveryNA,
          techTest: techTestNA,
          techTestRecovery: techTestRecoveryNA,
        }));
      }
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  }

  useEffect(() => {
    let cancelled = false;

    const fetchConfigValue = async () => {
      try {
        const response = await getConfigurationValues(
          "appsettings:generateIdmTicketNew",
        );

        if (cancelled) return;

        if (response?.statusCode === 200) {
          if (!cancelled) {
            setGenerateIdmTicketNew(
              response?.data?.generateIdmTicketNew?.toString() === "1",
            );
          }
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch config value:", error);
        }
      }
    };

    fetchConfigValue();

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!showCreateIdmTickets) {
        if (!cancelled) {
          setLoading(true);

          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "ASTT",
            "Roster Config",
          );
        }

        try {
          if (classRosterId !== null) {
            await fetchRosterConfigData(classRosterId, data);

            if (cancelled) return;

            if (data === "false") {
              await fetchDistributionTypes();

              if (cancelled) return;

              await fetchTicketsAndTrainees(classRosterId);

              if (cancelled) return;
            }
          }
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to fetch roster config data:", error);
          }
        } finally {
          if (!cancelled) {
            setLoading(false);
          }
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, [classRosterId, data, showCreateIdmTickets]);

  useEffect(() => {
    setTtfTrainerData([
      classRosterDetails.techEquipmentSolutionId === 14 &&
      classRosterDetails.ttfDateTime
        ? classRosterDetails.ttfDateTime
        : null,
      classRosterDetails.techEquipmentSolutionId !== 14 &&
      classRosterDetails.tciDateTime
        ? classRosterDetails.tciDateTime
        : null,
      classRosterDetails.techEquipmentSolutionId !== 14 &&
      classRosterDetails.techTestDateTime
        ? classRosterDetails.techTestDateTime
        : null,
      classRosterDetails.productionStartDate || null,
      classRosterDetails.productTrainingDateTime || null,
      classRosterDetails.trainerOracleId || null,
      classRosterDetails.trainerName || "",
      classRosterDetails.trainerEmail || "",
      classRosterDetails.techEquipmentSolutionId === 14,
    ]);
  }, [
    classRosterDetails.techEquipmentSolutionId,
    classRosterDetails.ttfDateTime,
    classRosterDetails.tciDateTime,
    classRosterDetails.techTestDateTime,
    classRosterDetails.productionStartDate,
    classRosterDetails.productTrainingDateTime,
    classRosterDetails.trainerOracleId,
    classRosterDetails.trainerName,
    classRosterDetails.trainerEmail,
  ]);

  useEffect(() => {
    if (prevClassRosterDetails.current === null) return;

    if (!isEqual(prevClassRosterDetails.current, classRosterDetails)) {
      setUnsavedChanges(true);
    }
  }, [classRosterDetails]);

  useEffect(() => {
    let cancelled = false;

    const fetchTechEquipment = async () => {
      if (classRosterDetails.techEquipmentSolutionId) {
        try {
          await fetchTechEquipmentSolutions(
            classRosterDetails.techEquipmentSolutionId,
          );
        } catch (error) {
          if (!cancelled) {
            console.error("Failed to fetch tech equipment solutions:", error);
          }
        }
      }
    };

    fetchTechEquipment();

    return () => {
      cancelled = true;
    };
  }, [classRosterDetails.techEquipmentSolutionId]);

  const validateTicketNumber = (ticketNumber) => {
    const pattern = /^RITM\d{7}$/;
    if (pattern.test(ticketNumber)) {
      setErrorMessage("");
      return true;
    } else {
      setIDMTicketNumber("");
      setSnack({
        open: true,
        message: t("validateTicketNumberER01"),
        severity: "error",
      });
      return false;
    }
  };

  const handleIDMTicketChange = (event) => {
    const value = event.target.value;
    setIDMTicketNumber(value);
  };

  // Validation helper functions
  const showErrorSnack = (message, setSnack, t) => {
    setSnack({
      open: true,
      message: t(message),
      severity: "error",
    });
  };

  const showErrorSnackWithParams = (message, params, setSnack, t) => {
    setSnack({
      open: true,
      message: t(message, params),
      severity: "error",
    });
  };

  // Individual validation functions
  const validateACCDateTime = (errorACCDateTime, setSnack, t) => {
    if (errorACCDateTime) {
      showErrorSnack("handleSaveRosterER09", setSnack, t);
      return false;
    }
    return true;
  };

  const validateSRWDateTime = (errorSRWDateTime, setSnack, t) => {
    if (errorSRWDateTime) {
      showErrorSnack("handleSaveRosterER10", setSnack, t);
      return false;
    }
    return true;
  };

  const validateSectionDateTimes = (sections, inputValues, setSnack, t) => {
    for (const section of sections) {
      if (inputValues[section.id]?.dateTimeError) {
        showErrorSnackWithParams(
          "handleSaveRosterDateTimeError",
          { section: t(section.id) },
          setSnack,
          t,
        );
        return false;
      }

      if (inputValues[section.id]?.endDateTimeError) {
        showErrorSnackWithParams(
          "handleSaveRosterEndDateTimeError",
          { section: t(section.id) },
          setSnack,
          t,
        );
        return false;
      }
    }
    return true;
  };

  const validateProductionStartDate = (
    productionStartDate,
    setErrorProductionDate,
    setSnack,
    t,
  ) => {
    if (!productionStartDate) {
      setErrorProductionDate(true);
      showErrorSnack("handleSaveRosterER01", setSnack, t);
      return false;
    }
    return true;
  };

  const validateNestingVsProduction = (
    nestingDateTime,
    productionStartDate,
    setErrorProductionDate,
    setErrorNestingStartDate,
    setSnack,
    t,
  ) => {
    if (nestingDateTime && nestingDateTime >= productionStartDate) {
      setErrorProductionDate(false);
      setErrorNestingStartDate(true);
      showErrorSnack("handleSaveRosterER05", setSnack, t);
      return false;
    }
    return true;
  };

  const validateNestingDateRange = (
    nestingDateTime,
    nestingEndDateTime,
    setErrorNestingStartDate,
    setErrorNestingEndDate,
    setSnack,
    t,
  ) => {
    // Case 1: Nesting end date exists but start date is missing.
    if (!nestingDateTime && nestingEndDateTime) {
      setErrorNestingStartDate(false);
      setErrorNestingEndDate(true);
      showErrorSnack("handleSaveRosterER06", setSnack, t);
      return false;
    }
    // Case 2: Nesting start date exists but end date is missing.
    if (nestingDateTime && !nestingEndDateTime) {
      setErrorNestingStartDate(false);
      setErrorNestingEndDate(true);
      showErrorSnack("handleSaveRosterER06", setSnack, t);
      return false;
    }

    // Case 3: Nesting start date less than end date.
    if (
      nestingDateTime &&
      nestingEndDateTime &&
      nestingDateTime > nestingEndDateTime
    ) {
      setErrorNestingStartDate(false);
      setErrorNestingEndDate(true);
      showErrorSnack("handleSaveRosterER06", setSnack, t);
      return false;
    }
    return true;
  };

  const validateNestingEndVsProduction = (
    nestingDateTime,
    nestingEndDateTime,
    productionStartDate,
    setErrorNestingStartDate,
    setErrorNestingEndDate,
    setSnack,
    t,
  ) => {
    const hasValidNestingRange =
      nestingDateTime &&
      nestingEndDateTime &&
      nestingDateTime <= nestingEndDateTime;

    const nestingEndExceedsProduction =
      hasValidNestingRange && nestingEndDateTime >= productionStartDate;

    if (nestingEndExceedsProduction) {
      setErrorNestingStartDate(false);
      setErrorNestingEndDate(true);
      showErrorSnack("handleSaveRosterER07", setSnack, t);
      return false;
    }
    return true;
  };

  const validateWaveRequired = (
    wave,
    errorWaveNumber,
    setErrorNestingEndDate,
    setErrorWaveNumber,
    setSnack,
    t,
  ) => {
    if (!wave || errorWaveNumber) {
      setErrorNestingEndDate(false);
      setErrorWaveNumber(true);
      showErrorSnack(
        !wave ? "handleSaveRosterER03" : "handleSaveRosterER011",
        setSnack,
        t,
      );
      return false;
    }
    return true;
  };

  const validateWaveFormat = (
    wave,
    setErrorNestingEndDate,
    setErrorWaveNumber,
    setSnack,
    t,
  ) => {
    const normalizedWave = wave.replace(",", ".");
    const isValidFormat = /^\d+\.\d+$/.test(normalizedWave);

    if (wave !== "" && !isValidFormat) {
      setErrorNestingEndDate(false);
      setErrorWaveNumber(true);
      showErrorSnack("handleSaveRosterER04", setSnack, t);
      return false;
    }
    return true;
  };

  const validateWaveUniqueness = (
    wave,
    alreadyAssignedWaves,
    setErrorNestingEndDate,
    setErrorWaveNumber,
    setSnack,
    t,
  ) => {
    if (!alreadyAssignedWaves) {
      return true;
    }

    const wavesArray = alreadyAssignedWaves.split(",");
    const isDuplicate = wavesArray.includes(wave);

    if (isDuplicate) {
      setErrorNestingEndDate(false);
      setErrorWaveNumber(true);
      showErrorSnack("handleSaveRosterER08", setSnack, t);
      return false;
    }
    return true;
  };

  // Main validation function - simplified
  const handleValidateInputs = () => {
    try {
      // Validate date/time errors
      if (!validateACCDateTime(errorACCDateTime, setSnack, t)) return false;
      if (!validateSRWDateTime(errorSRWDateTime, setSnack, t)) return false;
      if (!validateSectionDateTimes(sections, inputValues, setSnack, t))
        return false;

      // Validate production start date
      if (
        !validateProductionStartDate(
          classRosterDetails.productionStartDate,
          setErrorProductionDate,
          setSnack,
          t,
        )
      )
        return false;

      // Validate nesting dates
      if (
        !validateNestingVsProduction(
          classRosterDetails.nestingDateTime,
          classRosterDetails.productionStartDate,
          setErrorProductionDate,
          setErrorNestingStartDate,
          setSnack,
          t,
        )
      )
        return false;

      if (
        !validateNestingDateRange(
          classRosterDetails.nestingDateTime,
          classRosterDetails.nestingEndDateTime,
          setErrorNestingStartDate,
          setErrorNestingEndDate,
          setSnack,
          t,
        )
      )
        return false;

      if (
        !validateNestingEndVsProduction(
          classRosterDetails.nestingDateTime,
          classRosterDetails.nestingEndDateTime,
          classRosterDetails.productionStartDate,
          setErrorNestingStartDate,
          setErrorNestingEndDate,
          setSnack,
          t,
        )
      )
        return false;

      // Validate wave number
      if (
        !validateWaveRequired(
          classRosterDetails.wave,
          errorWaveNumber,
          setErrorNestingEndDate,
          setErrorWaveNumber,
          setSnack,
          t,
        )
      )
        return false;

      if (
        !validateWaveFormat(
          classRosterDetails.wave,
          setErrorNestingEndDate,
          setErrorWaveNumber,
          setSnack,
          t,
        )
      )
        return false;

      if (
        !validateWaveUniqueness(
          classRosterDetails.wave,
          classRosterDetails.alreadyAssignedWaves,
          setErrorNestingEndDate,
          setErrorWaveNumber,
          setSnack,
          t,
        )
      )
        return false;

      return true;
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
      return false;
    }
  };
  const handleSaveRosterConfigDetails = async () => {
    try {
      if (classRosterDetails) {
        let errorFlag = handleValidateInputs();
        if (errorFlag) {
          setErrorNestingStartDate(false);
          setErrorNestingEndDate(false);

          setErrorWaveNumber(false);

          setErrorProductionDate(false);

          handleDialogOpen(
            async () => {
              setLoading(true);

              const saveRosterConfigData = await saveRosterConfigDetails(
                classRosterDetails.classRosterId,
                classRosterDetails.classRequestId,
                classRosterDetails.isRosterClone,
                classRosterDetails.applyUpdateToAll,
                classRosterDetails.requestedBy,
                classRosterDetails,
              );

              if (saveRosterConfigData.status === true) {
                setLoading(false);

                setUnsavedChanges(false);
                prevClassRosterDetails.current = classRosterDetails;

                setSnack({
                  open: true,
                  message: t("handleSaveRosterSC01"),
                  severity: "success",
                });

                setTimeout(() => {
                  navigate(
                    `/home/searchrosters?classRequestId=${classRequestId}`,
                  );
                }, 2000);
              } else {
                setLoading(false);
                setSnack({
                  open: true,
                  message: t("handleSaveRosterER02"),
                  severity: "error",
                });
              }
            },
            t("dialogSaveTitle"),
            t("dialogSaveMessage"),
            [],
            true,
          );
        }
      }
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  };

  const handleCancel = () => {
    navigate(`/home/searchrosters?classRequestId=${classRequestId}`);
  };

  const insertIDMTicketDetails = async () => {
    try {
      if (validateTicketNumber(idmTicketNumber)) {
        handleDialogOpen(
          async () => {
            setLoading(true);

            if (classRosterId === null) {
              setLoading(false);
              return;
            }

            const existingTicket = ticketRows.some(
              (item) => item.idmTicketNumber === idmTicketNumber,
            );

            if (existingTicket) {
              setIDMTicketNumber("");
              setSnack({
                open: true,
                message: t("insertIDMTicketER01"),
                severity: "error",
              });
              setLoading(false);
              return;
            }

            const insertTicket = await insertIdmTicket(
              idmTicketNumber,
              {
                CreatedBy: localStorage.getItem("User"),
                ClassRosterId: classRosterId,
                IDMTicketNumber: idmTicketNumber,
              },
              classRosterId,
              true,
            );

            if (!insertTicket.status) {
              setIDMTicketNumber("");
              setSnack({
                open: true,
                message: t("insertIDMTicketER02"),
                severity: "error",
              });
              setLoading(false);
              return;
            }

            const idmTicketDetails = await getIdmDetails(classRosterId);

            if (idmTicketDetails.status) {
              const idmTicketData = idmTicketDetails.data.map((idmTicket) => ({
                id: idmTicket.idmTicketNumber,
                idmTicketNumber: idmTicket.idmTicketNumber,
                ticketType: idmTicket.ticketType,
                ticketCreateDate: idmTicket.ticketCreateDate,
                ticketOpenedBy: idmTicket.ticketOpenedBy,
                newClientProgram: idmTicket.newClientProgram,
                facilitiesTicketNumber: idmTicket.facilitiesTicketNumber,
                facilitiesTicketCreateDate:
                  idmTicket.facilitiesTicketCreateDate,
              }));

              setIDMTicketNumber("");
              setTicketRows(idmTicketData);
              setErrorMessage("");
              setSnack({
                open: true,
                message: t("insertIDMTIcketSC01"),
                severity: "success",
              });
            } else {
              setIDMTicketNumber("");
              setSnack({
                open: true,
                message: t("insertIDMTicketER03"),
                severity: "error",
              });
            }

            setLoading(false);
          },
          t("dialogAddTicketTitle"),
          `${t("dialogAddTicketMsg")} ${idmTicketNumber} ?`,
          [],
          true,
        );
      }
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  };

  const handleDeleteTicket = async (idmTicketId, facilitiesTicketNumber) => {
    try {
      handleDialogOpen(
        async () => {
          setLoading(true);

          if (classRosterId !== null) {
            const deleteTicket = await deleteIdmAndFacTicket(
              idmTicketId,
              classRosterId,
              facilitiesTicketNumber,
            );

            if (deleteTicket.status === true) {
              setSnack({
                open: true,
                message: t("deleteIDMTicketSC01"),
                severity: "success",
              });
              setIDMTicketNumber("");
              setTicketRows([]);

              const idmTicketDetails = await getIdmDetails(classRosterId);

              if (idmTicketDetails.status === true) {
                const idmTicketData = idmTicketDetails.data.map(
                  (idmTicket) => ({
                    id: idmTicket.idmTicketNumber,
                    idmTicketNumber: idmTicket.idmTicketNumber,
                    ticketType: idmTicket.ticketType,
                    ticketCreateDate: idmTicket.ticketCreateDate,
                    ticketOpenedBy: idmTicket.ticketOpenedBy,
                    newClientProgram: idmTicket.newClientProgram,
                    facilitiesTicketNumber: idmTicket.facilitiesTicketNumber,
                    facilitiesTicketCreateDate:
                      idmTicket.facilitiesTicketCreateDate,
                  }),
                );

                setTicketRows(idmTicketData);
              }
            } else {
              setSnack({
                open: true,
                message: t("deleteIDMTicketER01"),
                severity: "error",
              });
            }
          }

          setLoading(false);
        },
        t("dialogDeleteTicketTitle"),
        t("dialogDeleteTicketMsg"),
        [
          `${t("idmHeader01")}: ${idmTicketId}`,
          ...(facilitiesTicketNumber
            ? [`${t("idmHeader07")}: ${facilitiesTicketNumber}`]
            : []),
        ],
        true,
      );
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  };

  const handleRosterLock = async (isLocked) => {
    try {
      setLoading(true);

      if (classRosterId !== null) {
        const hasRosterLock = await lockRosterConfig({
          classRosterId: classRosterId,
          isLocked: isLocked ? 1 : 0,
          modifiedBy: localStorage.getItem("User"),
        });

        if (hasRosterLock.status === true) {
          setClassRosterDetails((prevState) => ({
            ...prevState,
            assignTraineeLockDateTime: isLocked
              ? moment().tz("America/New_York").format("YYYY-MM-DDTHH:mm")
              : null,
          }));

          if (isLocked) {
            await uploadAgentScheduleForRoster(classRosterId, classRequestId)
              .then(({ message }) => {
                setSnack({
                  open: true,
                  message: message,
                  severity: "success",
                });
              })
              .catch(({ statusCode, message }) => {
                setSnack({
                  open: true,
                  message: `Error [${statusCode}]: ${message}`,
                  severity: "error",
                });
              });
          } else {
            setSnack({
              open: true,
              message: isLocked ? t("rosterLockSC01") : t("rosterLockSC02"),
              severity: "success",
            });
          }
        } else {
          setSnack({
            open: true,
            message: t("rosterLockER01"),
            severity: "error",
          });
        }
      }

      setLoading(false);
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  };

  const handleAssignTrainees = () => {
    try {
      if (classRosterDetails) {
        let errorFlag = handleValidateInputs();
        if (errorFlag) {
          if (unsavedChanges) {
            handleDialogOpen(
              async () => {
                navigate(`/home/assignTrainees`, {
                  state: {
                    classRequestId: classRequestId,
                    classRosterId: classRosterId,
                  },
                });
              },
              t("unsavedChangeAlertTitle"),
              t("unsavedChangeAlertMsg"),
              [],
              false,
            );
          } else {
            navigate(`/home/assignTrainees`, {
              state: {
                classRequestId: classRequestId,
                classRosterId: classRosterId,
              },
            });
          }
        }
      }
    } catch {
      setLoading(false);
      setSnack({
        open: true,
        message: t("commonError01"),
        severity: "error",
      });
    }
  };

  const CustomPopper = (props) => {
    return <Popper {...props} placement="bottom-start" />;
  };

  // Helper function to check if section should show NA switch
  const shouldShowNASwitch = (sectionId) => {
    return sectionId !== "productTraining";
  };

  // Helper function to check if section should show host link
  const shouldShowHostLink = (sectionId) => {
    return sectionId === "clientSpecific" || sectionId === "ttf";
  };

  // Render NA Switch Control
  const renderNASwitchControl = (section, inputValues, handleSwitchChange) => {
    if (!shouldShowNASwitch(section.id)) {
      return null;
    }

    const isNA = inputValues[section.id].NA;

    return (
      <Box display="flex" alignItems="center" gap={0.75}>
        <Typography
          sx={{
            fontFamily: "Urbanist, Arial, sans-serif",
            fontSize: "11px",
            letterSpacing: "0.08em",
            color: isNA ? section.color : "#9e9e9e",
            fontWeight: isNA ? "bold" : "normal",
            transition: "color 0.2s ease, font-weight 0.2s ease",
          }}
        >
          N/A
        </Typography>
        <CustomTooltip title={t("toolTipSwitch")}>
          <FormControlLabel
            sx={{ margin: 0 }}
            control={
              <AntSwitch
                name="NA"
                customBackgroundColor={section.color}
                checked={!isNA}
                onChange={(event) => handleSwitchChange(event, section.id)}
              />
            }
            onClick={(event) => event.stopPropagation()}
            onFocus={(event) => event.stopPropagation()}
          />
        </CustomTooltip>
        <Typography
          sx={{
            fontFamily: "Urbanist, Arial, sans-serif",
            fontSize: "11px",
            letterSpacing: "0.08em",
            color: !isNA ? section.color : "#9e9e9e",
            fontWeight: !isNA ? "bold" : "normal",
            transition: "color 0.2s ease, font-weight 0.2s ease",
            marginRight: 1.5,
          }}
        >
          Active
        </Typography>
      </Box>
    );
  };

  // Render Clear/Disable Section Button
  const renderClearSectionButton = (
    section,
    disabledSections,
    handleClearSection,
  ) => {
    const isDisabled = disabledSections[section.id];
    const tooltipTitle = isDisabled ? t("toolTipDisable") : t("toolTipClear");
    const Icon = isDisabled ? BlockIcon : NotInterestedOutlinedIcon;

    return (
      <CustomTooltip title={tooltipTitle}>
        <IconButton
          id="icon-button-toggle"
          type="button"
          onClick={() => handleClearSection(section.id)}
        >
          <Icon sx={classes.clearSectionButton} />
        </IconButton>
      </CustomTooltip>
    );
  };

  // Render Accordion Header
  const renderAccordionHeader = (
    section,
    inputValues,
    disabledSections,
    handleSwitchChange,
    handleClearSection,
    handleSummaryClick,
  ) => {
    return (
      <AccordionSummary
        id={`${section.id}bh-header`}
        sx={classes.accordionSummary}
        aria-controls={`${section.id}bh-content`}
        onClick={handleSummaryClick}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
        >
          <Typography sx={{ ...classes.label, color: section.color }}>
            <b>{t(section.id)}</b>
          </Typography>
          <Box display="flex" alignItems="center">
            {renderNASwitchControl(section, inputValues, handleSwitchChange)}
            {renderClearSectionButton(
              section,
              disabledSections,
              handleClearSection,
            )}
          </Box>
        </Box>
      </AccordionSummary>
    );
  };

  // Get label styles with error handling
  const getDateTimeLabelStyles = (
    section,
    disabledSections,
    errorNestingStartDate,
  ) => {
    const baseStyles = {
      ...classes.label,
      ...(disabledSections[section.id] ? classes.disabledLabel : {}),
    };

    if (section.id === "nesting" && errorNestingStartDate) {
      return { ...baseStyles, color: "red" };
    }

    return { ...baseStyles, color: "#3F5765" };
  };

  // Render DateTime Status Icons
  const renderDateTimeStatusIcons = (sectionInputs) => {
    if (!sectionInputs.dateTime) {
      return null;
    }

    const isTentative = sectionInputs.isTentative;

    if (isTentative === 0) {
      return (
        <CustomTooltip title={t("toolTipConfirm")}>
          <DoneIcon sx={{ color: "green" }} />
        </CustomTooltip>
      );
    }

    if (isTentative === 1) {
      return (
        <CustomTooltip title={t("toolTipTentative")}>
          <QuestionMarkIcon sx={{ color: "red" }} />
        </CustomTooltip>
      );
    }

    return null;
  };

  // Render Clear Button for DateTime
  const renderDateTimeClearButton = (
    sectionId,
    fieldName,
    value,
    handleSectionValueChange,
  ) => {
    if (!value) {
      return null;
    }

    return (
      <Tooltip title={t("toolTipClear")}>
        <IconButton
          onClick={() => handleSectionValueChange("", fieldName, sectionId)}
          edge="end"
        >
          <ClearIcon />
        </IconButton>
      </Tooltip>
    );
  };

  // Render DateTime Picker Field
  const renderDateTimePicker = (
    section,
    fieldName,
    labelKey,
    inputValues,
    disabledSections,
    errorState,
    handleSectionValueChange,
  ) => {
    const isEndDateTime = fieldName === "endDateTime";
    const labelStyles = isEndDateTime
      ? {
          ...classes.label,
          ...(disabledSections[section.id] ? classes.disabledLabel : {}),
          ...(errorNestingEndDate ? { color: "red" } : { color: "#3F5765" }),
        }
      : getDateTimeLabelStyles(
          section,
          disabledSections,
          errorNestingStartDate,
        );

    const showDnSyncIcon =
      fieldName === "dateTime" &&
      (section.id === "ttf" || section.id === "productTraining");

    return (
      <Grid item xs={12} md={6}>
        <Typography sx={labelStyles}>
          {showDnSyncIcon && <DataNitivSyncIcon />}
          <b>{t(labelKey)}</b>
        </Typography>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DateTimePicker
            value={inputValues[section.id][fieldName] || null}
            disabled={disabledSections[section.id]}
            onChange={(newValue) => {
              const formattedValue =
                newValue && newValue instanceof Date && !isNaN(newValue)
                  ? format(newValue, "yyyy-MM-dd'T'HH:mm")
                  : "Invalid Date";

              handleSectionValueChange(formattedValue, fieldName, section.id);
            }}
            format="yyyy-MM-dd HH:mm"
            ampm={false}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                size="small"
                variant="outlined"
                name={fieldName}
                error={errorState}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {!isEndDateTime &&
                        renderDateTimeStatusIcons(inputValues[section.id])}
                      {renderDateTimeClearButton(
                        section.id,
                        fieldName,
                        inputValues[section.id][fieldName],
                        handleSectionValueChange,
                      )}
                      {params.InputProps?.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </LocalizationProvider>
      </Grid>
    );
  };

  // Render Max Length Warning Icon
  const renderMaxLengthWarning = (fieldKey, value, maxLength, tooltipKey) => {
    if (focusedField !== fieldKey || !value || value.length !== maxLength) {
      return null;
    }

    return (
      <CustomTooltip title={t(tooltipKey)}>
        <ReportProblemOutlinedIcon
          fontSize="small"
          color="warning"
          sx={{
            cursor: "pointer",
            transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
            "&:hover": {
              transform: "scale(1.3)",
              opacity: 0.8,
            },
          }}
        />
      </CustomTooltip>
    );
  };

  // Render Text Field Input Adornment
  const renderTextFieldAdornment = (
    section,
    fieldName,
    value,
    maxLength,
    tooltipKey,
    handleSectionValueChange,
  ) => {
    if (!value) {
      return null;
    }

    const fieldKey = `${section.id}-${fieldName}`;

    return (
      <InputAdornment position="end">
        {renderMaxLengthWarning(fieldKey, value, maxLength, tooltipKey)}
        <CustomTooltip title={t("toolTipClear")}>
          <IconButton
            onClick={() => handleSectionValueChange("", fieldName, section.id)}
            edge="end"
          >
            <ClearIcon />
          </IconButton>
        </CustomTooltip>
      </InputAdornment>
    );
  };

  // Get Text Field Styles
  const getTextFieldStyles = (
    section,
    disabledSections,
    fieldName,
    value,
    maxLength,
  ) => {
    const fieldKey = `${section.id}-${fieldName}`;
    const isMaxLength =
      focusedField === fieldKey && value && value.length === maxLength;

    return {
      ...classes.formControl,
      ...(disabledSections[section.id] ? classes.disabledInput : {}),
      ...(isMaxLength ? classes.maxLengthReached : {}),
    };
  };

  // Render Location Select Field
  const renderLocationField = (
    section,
    inputValues,
    disabledSections,
    handleSectionValueChange,
  ) => {
    return (
      <Grid item xs={12} md={6}>
        <Typography
          sx={{
            ...classes.label,
            ...(disabledSections[section.id] ? classes.disabledLabel : {}),
          }}
        >
          <b>{t("location")}</b>
        </Typography>
        <FormControl
          fullWidth
          size="small"
          sx={{
            ...classes.label,
            ...(disabledSections[section.id] ? classes.disabledLabel : {}),
          }}
          disabled={disabledSections[section.id]}
        >
          <Select
            name="location"
            value={inputValues[section.id].location || "NA"}
            onChange={(event) =>
              handleSectionValueChange(
                event.target.value,
                event.target.name,
                section.id,
              )
            }
          >
            <MenuItem value="NA">Select</MenuItem>
            <MenuItem value="Zoom">Zoom</MenuItem>
            <MenuItem value="Teams">Teams</MenuItem>
            <MenuItem value="WebEx">WebEx</MenuItem>
            <MenuItem value="Room/In Person">Room/In Person</MenuItem>
            <MenuItem value="Other">Other</MenuItem>
          </Select>
        </FormControl>
      </Grid>
    );
  };

  // Render Generic Text Field (Meeting Link, Password, Host Link)
  const renderTextField = (
    section,
    fieldName,
    labelKey,
    placeholderKey,
    maxLength,
    tooltipKey,
    inputValues,
    disabledSections,
    handleSectionValueChange,
    setFocusedField,
  ) => {
    const fieldValue = inputValues[section.id][fieldName] || "";

    return (
      <Grid item xs={12} md={6}>
        <Typography
          sx={{
            ...classes.label,
            ...(disabledSections[section.id] ? classes.disabledLabel : {}),
          }}
        >
          <b>{t(labelKey)}</b>
        </Typography>
        <TextField
          fullWidth
          name={fieldName}
          value={fieldValue}
          size="small"
          variant="outlined"
          placeholder={t(placeholderKey)}
          sx={getTextFieldStyles(
            section,
            disabledSections,
            fieldName,
            fieldValue,
            maxLength,
          )}
          disabled={disabledSections[section.id]}
          onChange={(event) =>
            handleSectionValueChange(
              event.target.value,
              event.target.name,
              section.id,
            )
          }
          onFocus={() => setFocusedField(`${section.id}-${fieldName}`)}
          onBlur={() => setFocusedField(null)}
          inputProps={{ maxLength }}
          InputProps={{
            endAdornment: renderTextFieldAdornment(
              section,
              fieldName,
              fieldValue,
              maxLength,
              tooltipKey,
              handleSectionValueChange,
            ),
          }}
        />
      </Grid>
    );
  };

  // Render Host Link Field (conditional)
  const renderHostLinkField = (
    section,
    inputValues,
    disabledSections,
    handleSectionValueChange,
    setFocusedField,
  ) => {
    if (!shouldShowHostLink(section.id)) {
      return null;
    }

    return (
      <Grid item xs={12} md={6}>
        <Typography
          sx={{
            ...classes.label,
            ...(disabledSections[section.id] ? classes.disabledLabel : {}),
          }}
        >
          <b>{t("hostPasscode")}</b>
        </Typography>
        <FormControl fullWidth size="small" sx={classes.formControl}>
          {
            renderTextField(
              section,
              "hostLink",
              "hostPasscode",
              "inputHostPasscode",
              30,
              "toolTipWarn30",
              inputValues,
              disabledSections,
              handleSectionValueChange,
              setFocusedField,
            ).props.children[1]
          }
        </FormControl>
      </Grid>
    );
  };

  // Main render function - simplified
  const renderSection = (section) => {
    if (!inputValues[section.id]?.display) {
      return null;
    }

    const isNesting = section.id === "nesting";
    const isClientSpecific = section.id === "clientSpecific";

    return (
      <Grid item xs={12} key={section.id}>
        <Box
          sx={{
            ...classes.groupContainer,
            borderColor: section.color,
            boxShadow: `0px 0px 3px ${section.color}`,
          }}
        >
          <Accordion expanded={expandedPanels[section.id]}>
            {renderAccordionHeader(
              section,
              inputValues,
              disabledSections,
              handleSwitchChange,
              handleClearSection,
              handleSummaryClick,
            )}
            <AccordionDetails sx={classes.accordionDetails}>
              <Grid container spacing={2}>
                {/* DateTime Picker */}
                {!isClientSpecific &&
                  renderDateTimePicker(
                    section,
                    "dateTime",
                    isNesting ? "startDateTime" : "dateTime",
                    inputValues,
                    disabledSections,
                    (isNesting && errorNestingStartDate) ||
                      inputValues[section.id]?.dateTimeError,
                    handleSectionValueChange,
                  )}

                {/* End DateTime for Nesting */}
                {isNesting &&
                  renderDateTimePicker(
                    section,
                    "endDateTime",
                    "endDateTime",
                    inputValues,
                    disabledSections,
                    errorNestingEndDate ||
                      inputValues[section.id]?.endDateTimeError,
                    handleSectionValueChange,
                  )}

                {/* Location */}
                {renderLocationField(
                  section,
                  inputValues,
                  disabledSections,
                  handleSectionValueChange,
                )}

                {/* Meeting Link */}
                {renderTextField(
                  section,
                  "meetingLink",
                  "meetingLink",
                  "inputMeetingLink",
                  300,
                  "toolTipWarn300",
                  inputValues,
                  disabledSections,
                  handleSectionValueChange,
                  setFocusedField,
                )}

                {/* Meeting Password */}
                {renderTextField(
                  section,
                  "meetingPassword",
                  "meetingPassword",
                  "inputMeetingPassword",
                  30,
                  "toolTipWarn30",
                  inputValues,
                  disabledSections,
                  handleSectionValueChange,
                  setFocusedField,
                )}

                {/* Host Link (conditional) */}
                {renderHostLinkField(
                  section,
                  inputValues,
                  disabledSections,
                  handleSectionValueChange,
                  setFocusedField,
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Box>
      </Grid>
    );
  };

  return (
    <>
      {loading && <BackdropComponent />}
      <Dialog
        open={dialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => handleDialogClose(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" sx={{ fontSize: "1.4rem" }}>
          {dialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            sx={{ fontSize: "1.2rem" }}
          >
            {dialogMessage}
            {dialogBulletList.length > 0 && (
              <>
                <div className={cssClasses.marginTop16} />
                <ul>
                  {dialogBulletList.map((message, index) => (
                    <li key={`${message}-${index}`}>{message}</li>
                  ))}
                </ul>
              </>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ "& .MuiButtonRoot": { fontSize: "1.2rem" } }}>
          <Button onClick={() => handleDialogClose(false)} color="primary">
            {isConfirmationDialog
              ? t("dialogDefaultBtn02")
              : t("dialogDefaultBtn04")}
          </Button>
          <Button
            onClick={() => handleDialogClose(true)}
            color="primary"
            autoFocus
          >
            {isConfirmationDialog
              ? t("dialogDefaultBtn01")
              : t("dialogDefaultBtn03")}
          </Button>
        </DialogActions>
      </Dialog>

      <CssBaseline />
      <Paper
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 95px)",
          boxShadow: "0px 5px 15px rgba(0, 0, 0, 0.35)",
          p: 1.5,
          //  pb: 1,
          overflow: "visible",
        }}
      >
        <Box sx={{ flexShrink: 0 }}>
          <Grid container spacing={1}>
            {/* ── Row 1: title | chips | program + last modified ── */}
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                {/* Left: title + chips */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    flexWrap: "wrap",
                  }}
                >
                  <Typography sx={{ fontSize: "16px" }}>
                    <b>
                      {type === "clone"
                        ? t("cloneRosterConfig")
                        : t("editRosterConfig")}
                    </b>
                  </Typography>
                  <CustomTooltip title={t("ogTitle")} arrow>
                    <Chip label="OG" sx={classes.chipOG} />
                  </CustomTooltip>
                  <CustomTooltip title={t("ldTitle")} arrow>
                    <Chip label="L&D" sx={classes.chipLD} />
                  </CustomTooltip>
                  <CustomTooltip title={t("wfmTitle")} arrow>
                    <Chip label="WFM" sx={classes.chipWFM} />
                  </CustomTooltip>
                  <CustomTooltip title={t("taTitle")} arrow>
                    <Chip label="TA" sx={classes.chipTA} />
                  </CustomTooltip>
                  <CustomTooltip title={t("opsTitle")} arrow>
                    <Chip label="OPS" sx={classes.chipOPS} />
                  </CustomTooltip>
                  <Typography sx={classes.typographyTime}>
                    {t("timeShown")}
                  </Typography>
                </Box>

                {/* Right: program + last modified — edit mode only */}
                {type === "edit" && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 3,
                      flexShrink: 0,
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "11px",
                          color: "text.secondary",
                          mb: 0.2,
                        }}
                      >
                        <DataNitivSyncIcon />
                        {t("program")}
                      </Typography>
                      <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                        {classRosterDetails.program?.split(",").length > 1 ? (
                          <>
                            {isProgramExpanded ? (
                              <>
                                {classRosterDetails.program
                                  ?.split(",")
                                  .map((item, idx) => (
                                    <span
                                      key={`${idx}-${item}`}
                                      style={{
                                        display: "block",
                                        fontSize: "12px",
                                      }}
                                    >
                                      {item}
                                    </span>
                                  ))}
                                <CustomTooltip
                                  title={t("click_to_collapse")}
                                  placement="bottom"
                                  arrow
                                >
                                  <IconButton
                                    sx={{
                                      cursor: "pointer",
                                      color: "#3299FF",
                                      p: 0,
                                      fontSize: "12px",
                                    }}
                                    onClick={(e) => {
                                      setIsProgramExpanded(false);
                                      e.stopPropagation();
                                    }}
                                  >
                                    {t("all_programs")}
                                  </IconButton>
                                </CustomTooltip>
                              </>
                            ) : (
                              <>
                                {classRosterDetails.program.split(",")[0]}{" "}
                                <CustomTooltip
                                  title={t("click_to_expand")}
                                  placement="bottom"
                                  arrow
                                >
                                  <IconButton
                                    sx={{
                                      cursor: "pointer",
                                      color: "#3299FF",
                                      p: 0,
                                      fontSize: "12px",
                                    }}
                                    onClick={(e) => {
                                      setIsProgramExpanded(true);
                                      e.stopPropagation();
                                    }}
                                  >
                                    {`+${classRosterDetails.program.split(",").length - 1}`}
                                  </IconButton>
                                </CustomTooltip>
                              </>
                            )}
                          </>
                        ) : (
                          classRosterDetails.program
                        )}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography
                        sx={{
                          fontSize: "11px",
                          color: "text.secondary",
                          mb: 0.2,
                        }}
                      >
                        {t("lastModified")}
                      </Typography>
                      <Typography sx={{ fontSize: "12px", fontWeight: 500 }}>
                        {classRosterDetails.modifiedBy}&nbsp;&#124;&nbsp;
                        {classRosterDetails.modfiedDateTime
                          ? moment
                              .utc(classRosterDetails.modfiedDateTime)
                              .format("DD-MM-YYYY hh:mm A")
                          : ""}
                      </Typography>
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>

            {/* ── Row 2: info bar — identity fields + goal fields ── */}
            <Grid item xs={12}>
              <Paper
                elevation={0}
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  gap: 2,
                  px: 2,
                  py: 1.5,
                  backgroundColor: "background.default",
                  border: "0.5px solid",
                  borderColor: "divider",
                  borderRadius: 2,
                  flexWrap: "nowrap",
                }}
              >
                {/* Class Roster ID — edit only */}
                {type === "edit" && (
                  <Box sx={{ flex: "0 0 80px" }}>
                    <Typography
                      sx={{
                        fontSize: "11px",
                        color: "text.secondary",
                        mb: 0.5,
                      }}
                    >
                      {t("classRosterId")}
                    </Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                      {classRosterId}
                    </Typography>
                  </Box>
                )}

                {/* DataNitiv — edit only */}
                {type === "edit" && (
                  <Box sx={{ flex: "0 0 190px" }}>
                    <Typography
                      sx={{
                        fontSize: "11px",
                        color: "text.secondary",
                        mb: 0.5,
                      }}
                    >
                      {t("dataNitivClassReferenceName")}
                    </Typography>
                    <TextField
                      size="small"
                      placeholder="TC_####_#####"
                      name="dataNitivClassReference"
                      value={classRosterDetails.dataNitivClassReference}
                      onChange={(event) =>
                        handleValueChange(event.target.name, event.target.value)
                      }
                      inputProps={{ maxLength: 13 }}
                      fullWidth
                      sx={{
                        ...classes.inputSmall,
                        "& .MuiFormHelperText-root": {
                          color: errorDataNitivClassRef ? "red" : "inherit",
                        },
                      }}
                    />
                  </Box>
                )}

                {/* Wave — edit only */}
                {type === "edit" && (
                  <Box sx={{ flex: "0 0 130px" }}>
                    <Typography
                      sx={{
                        fontSize: "11px",
                        mb: 0.5,
                        color: errorWaveNumber ? "red" : "text.secondary",
                      }}
                    >
                      <sup style={{ color: "red" }}>*</sup>
                      {t("wave")}
                    </Typography>
                    <TextField
                      required
                      name="wave"
                      size="small"
                      placeholder={t("wave")}
                      value={classRosterDetails.wave}
                      onChange={(e) =>
                        handleValueChange(e.target.name, e.target.value)
                      }
                      onKeyDown={handleKeyDown}
                      type="number"
                      inputProps={{
                        inputMode: "decimal",
                        step: getStepValue(classRosterDetails.wave),
                        min: "0",
                        max: "999999999.9999",
                        pattern: "[0-9]*\\.?[0-9]*",
                      }}
                      error={errorWaveNumber}
                      helperText={
                        errorWaveNumber ? "Must be 0 - 999,999,999.9999" : ""
                      }
                      onBlur={(event) => formatWaveNumber(event.target.value)}
                      fullWidth
                    />
                  </Box>
                )}

                {/* Divider — edit only */}
                {type === "edit" && (
                  <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />
                )}

                {/* Class Fill Goal */}
                <Box sx={{ flex: "0 0 120px" }}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: pillThemeConfig.TA.primaryColor,
                      mb: 0.5,
                    }}
                  >
                    <DataNitivSyncIcon />
                    {t("classFillGoal", "Class Fill Goal")}
                  </Typography>
                  <TextField
                    fullWidth
                    name="classFillGoal"
                    size="small"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={classRosterDetails.classFillGoal ?? ""}
                    onChange={(e) =>
                      handleValueChange(
                        e.target.name,
                        e.target.value === ""
                          ? null
                          : parseFloat(e.target.value),
                      )
                    }
                    placeholder="0"
                  />
                </Box>
                
                {/* Nesting Fill Goal */}
                <Box sx={{ flex: "0 0 120px" }}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: pillThemeConfig.LD.primaryColor,
                      mb: 0.5,
                    }}
                  >
                    {t("nestingFillGoal", "Nesting Fill Goal")}
                  </Typography>
                  <TextField
                    fullWidth
                    name="nestingFillGoal"
                    size="small"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={classRosterDetails.nestingFillGoal ?? ""}//need to update
                    onChange={(e) =>
                      handleValueChange(
                        e.target.name,
                        e.target.value === ""
                          ? null
                          : parseFloat(e.target.value),
                      )
                    }
                    placeholder="0"
                  />
                </Box>

                {/* Billable */}
                <Box sx={{ flex: "0 0 110px" }}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: pillThemeConfig.WFM.primaryColor,
                      mb: 0.5,
                    }}
                  >
                    <DataNitivSyncIcon />
                    {t("billable", "Billable")}
                  </Typography>
                  <TextField
                    fullWidth
                    name="productionFillGoalBillable"
                    size="small"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={classRosterDetails.productionFillGoalBillable ?? ""}
                    onChange={(e) =>
                      handleValueChange(
                        e.target.name,
                        e.target.value === ""
                          ? null
                          : parseFloat(e.target.value),
                      )
                    }
                    placeholder="0"
                  />
                </Box>

                {/* Non-Billable */}
                <Box sx={{ flex: "0 0 120px" }}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: pillThemeConfig.WFM.primaryColor,
                      mb: 0.5,
                    }}
                  >
                    <DataNitivSyncIcon />
                    {t("nonBillable", "Non-Billable")}
                  </Typography>
                  <TextField
                    fullWidth
                    name="productionFillGoalNonBillable"
                    size="small"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={
                      classRosterDetails.productionFillGoalNonBillable ?? ""
                    }
                    onChange={(e) =>
                      handleValueChange(
                        e.target.name,
                        e.target.value === ""
                          ? null
                          : parseFloat(e.target.value),
                      )
                    }
                    placeholder="0"
                  />
                </Box>

                {/* Prod Fill Goal — read-only computed */}
                <Box sx={{ flex: "0 0 110px" }}>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: pillThemeConfig.WFM.primaryColor,
                      mb: 0.5,
                    }}
                  >
                    <DataNitivSyncIcon />
                    {t("prodFillGoal", "Prod Fill Goal")}
                  </Typography>
                  <Box
                    sx={{
                      height: "40px", // matches MUI TextField size="small" height
                      display: "flex",
                      alignItems: "center",
                      px: 1,
                      border: "1px solid",
                      borderColor: "divider",
                      borderRadius: 1,
                      backgroundColor: "action.disabledBackground",
                    }}
                  >
                    <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                      {totalProdFillGoal}
                    </Typography>
                  </Box>
                </Box>

                {/* Divider */}
                <Divider orientation="vertical" flexItem sx={{ mx: 0.5 }} />              
              </Paper>
            </Grid>
          </Grid>

          <Divider orientation="horizontal" flexItem sx={{ my: 3 }} />
        </Box>

        <Box
          display="flex"
          flexDirection="row"
          alignItems="stretch"
          sx={{
            flexGrow: 1,
            minHeight: 0,
            overflowY: "auto",
            position: "relative", // helps with repaint
            zIndex: 0, // ensures it's layered correctly
            transform: "translateZ(0)", // forces GPU layer
          }}
        >
          {/* Left Section */}
          <Grid container spacing={2} flex="1">
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  ...classes.label,
                  color: pillThemeConfig.TA.primaryColor,
                }}
              >
                <b>{t("techEquipmentSolution")}</b>
              </Typography>
              <FormControl fullWidth size="small" sx={classes.formControl}>
                <Select
                  name="techEquipmentSolutionId"
                  value={classRosterDetails.techEquipmentSolutionId || "1"}
                  onChange={(event) =>
                    handleValueChange(event.target.name, event.target.value)
                  }
                >
                  {techEquipSolutionOption.map((value, index) => (
                    <MenuItem
                      key={value.TechEquipmentSolutionId}
                      value={value.TechEquipmentSolutionId}
                    >
                      {value.TechEquipmentSolution}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            {type === "edit" && (
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    ...classes.label,
                    color: pillThemeConfig.TA.primaryColor,
                  }}
                >
                  <b>{t("distributionType")}</b>
                </Typography>
                <FormControl fullWidth size="small" sx={classes.formControl}>
                  <Select
                    name="distributionTypeId"
                    value={classRosterDetails.distributionTypeId || "1"}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.value)
                    }
                  >
                    {distributionTypeOption.map((value, index) => (
                      <MenuItem
                        key={value.DistributionTypeId}
                        value={value.DistributionTypeId}
                      >
                        {value.DistributionType}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="accNA"
                    checked={classRosterDetails.accNA}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    sx={{
                      mr: 1,
                    }}
                  />
                }
                label={t("accDateTime")}
                labelPlacement="start"
                sx={{
                  marginLeft: 0,
                }}
                componentsProps={{
                  typography: {
                    sx: {
                      color: pillThemeConfig.OG.primaryColor,
                      fontWeight: "bold",
                    },
                  },
                }}
              />
              {classRosterDetails.accNA && (
                <Box component="span" sx={{ ...classes.label, marginLeft: 1 }}>
                  <b>N/A</b>
                </Box>
              )}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  value={
                    !classRosterDetails.accNA
                      ? classRosterDetails.accDateTime || null
                      : null
                  }
                  onChange={(newValue) => {
                    if (
                      newValue &&
                      newValue instanceof Date &&
                      !isNaN(newValue)
                    ) {
                      handleValueChange(
                        "accDateTime",
                        format(newValue, "yyyy-MM-dd'T'HH:mm"),
                      );
                    } else {
                      handleValueChange("accDateTime", "Invalid Date");
                    }
                  }}
                  disabled={classRosterDetails.accNA}
                  format="yyyy-MM-dd HH:mm"
                  ampm={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                      name="accDateTime"
                      error={errorACCDateTime}
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...classes.formControl,
                        ...(classRosterDetails.accNA
                          ? classes.disabledInput
                          : {}),
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {classRosterDetails.accDateTime && (
                              <Tooltip title={t("toolTipClear")}>
                                <IconButton
                                  onClick={() =>
                                    handleValueChange("accDateTime", "")
                                  }
                                  edge="end"
                                >
                                  <ClearIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                            {params.InputProps?.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  ...classes.label,
                  color: pillThemeConfig.OG.primaryColor,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <b>{t("ogName")}</b>{" "}
                <span style={{ color: "black" }}>
                  {classRosterDetails.ogEmail || ""}
                </span>
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  freeSolo
                  options={searchOGResults}
                  getOptionLabel={(option) => option.Display || ""}
                  onInputChange={handleOGInputChange}
                  onChange={handleOGSelect}
                  inputValue={classRosterDetails.ogName || ""}
                  PopperComponent={CustomPopper}
                  open={isOGAutocompleteOpen && searchOGResults.length > 0}
                  onOpen={() => setIsOGAutocompleteOpen(true)}
                  onClose={() => setIsOGAutocompleteOpen(false)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      name="ogName"
                      size="small"
                      variant="outlined"
                      sx={classes.formControl}
                      placeholder={t("inputOGName")}
                      value={classRosterDetails.ogName || ""}
                      onChange={(event) =>
                        handleValueChange(event.target.name, event.target.value)
                      }
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          if (
                            isOGAutocompleteOpen &&
                            searchOGResults.length > 0
                          ) {
                            return;
                          }
                          handleOGSearch(event, event.target.value);
                          setIsOGAutocompleteOpen(true);
                        }
                      }}
                      InputProps={{
                        maxLength: 50,
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            <CustomTooltip title={t("toolTipSearch")}>
                              <IconButton
                                id="icon-button-search"
                                type="button"
                                onClick={(event) =>
                                  handleOGSearch(
                                    event,
                                    classRosterDetails.ogName,
                                  )
                                }
                              >
                                <SearchIcon />
                              </IconButton>
                            </CustomTooltip>
                            {params.InputProps.endAdornment}
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="srwDownloadDueNA"
                    checked={classRosterDetails.srwDownloadDueNA}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                    sx={{
                      mr: 1,
                    }}
                  />
                }
                label={t("srwDateTime")}
                labelPlacement="start"
                sx={{
                  marginLeft: 0,
                }}
                componentProps={{
                  typography: {
                    sx: {
                      color: pillThemeConfig.OG.primaryColor,
                      fontWeight: "bold",
                    },
                  },
                }}
              />
              {classRosterDetails.srwDownloadDueNA && (
                <Box component="span" sx={{ ...classes.label, marginLeft: 1 }}>
                  <b>NA</b>
                </Box>
              )}
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DateTimePicker
                  value={
                    !classRosterDetails.srwDownloadDueNA
                      ? classRosterDetails.srwDateTime || null
                      : null
                  }
                  onChange={(newValue) => {
                    if (
                      newValue &&
                      newValue instanceof Date &&
                      !isNaN(newValue)
                    ) {
                      handleValueChange(
                        "srwDateTime",
                        format(newValue, "yyyy-MM-dd'T'HH:mm"),
                      );
                    } else {
                      handleValueChange("srwDateTime", "Invalid Date");
                    }
                  }}
                  disabled={classRosterDetails.srwDownloadDueNA}
                  format="yyyy-MM-dd HH:mm"
                  ampm={false}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                      name="srwDateTime"
                      error={errorSRWDateTime}
                      InputLabelProps={{ shrink: true }}
                      sx={{
                        ...classes.formControl,
                        ...(classRosterDetails.srwDownloadDueNA
                          ? classes.disabledInput
                          : {}),
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {classRosterDetails.srwDateTime && (
                              <Tooltip title={t("toolTipClear")}>
                                <IconButton
                                  onClick={() =>
                                    handleValueChange("srwDateTime", "")
                                  }
                                  edge="end"
                                >
                                  <ClearIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                            {params.InputProps?.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  ...classes.label,
                  color: pillThemeConfig.OG.primaryColor,
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <b>{t("fdoName")}</b>{" "}
                <span style={{ color: "black" }}>
                  {classRosterDetails.fdoEmail || ""}
                </span>
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  freeSolo
                  options={searchFDOResults}
                  getOptionLabel={(option) => option.Display || ""}
                  onInputChange={handleFDOInputChange}
                  onChange={handleFDOSelect}
                  inputValue={classRosterDetails.fdoName || ""}
                  PopperComponent={CustomPopper}
                  open={isFDOAutocompleteOpen && searchFDOResults.length > 0}
                  onOpen={() => setIsFDOAutocompleteOpen(true)}
                  onClose={() => setIsFDOAutocompleteOpen(false)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      name="fdoName"
                      size="small"
                      variant="outlined"
                      sx={classes.formControl}
                      placeholder={t("inputFDOName")}
                      value={classRosterDetails.fdoName || ""}
                      onChange={(event) =>
                        handleValueChange(event.target.name, event.target.value)
                      }
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          if (
                            isFDOAutocompleteOpen &&
                            searchFDOResults.length > 0
                          ) {
                            return;
                          }
                          handleFDOSearch(event, event.target.value);
                          setIsFDOAutocompleteOpen(true);
                        }
                      }}
                      InputProps={{
                        maxLength: 50,
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            <CustomTooltip title={t("toolTipSearch")}>
                              <IconButton
                                id="icon-button-search"
                                type="button"
                                onClick={(event) =>
                                  handleFDOSearch(
                                    event,
                                    classRosterDetails.fdoName,
                                  )
                                }
                              >
                                <SearchIcon />
                              </IconButton>
                            </CustomTooltip>
                            {params.InputProps.endAdornment}
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  ...classes.label,
                  color: errorProductionDate
                    ? "red"
                    : pillThemeConfig.WFM.primaryColor,
                }}
              >
                <DataNitivSyncIcon />
                <b>
                  {t("productionStartDate")}
                  <sup className={cssClasses.colorRed}>*</sup>
                </b>
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={
                    classRosterDetails.productionStartDate
                      ? moment(classRosterDetails.productionStartDate).toDate()
                      : null
                  }
                  onChange={(newValue) => {
                    if (
                      newValue &&
                      newValue instanceof Date &&
                      !isNaN(newValue)
                    ) {
                      handleValueChange(
                        "productionStartDate",
                        format(newValue, "yyyy-MM-dd"),
                      );
                    } else {
                      handleValueChange("productionStartDate", "Invalid Date");
                    }
                  }}
                  format="yyyy-MM-dd"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                      variant="outlined"
                      name="productionStartDate"
                      error={errorProductionDate}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {classRosterDetails.productionStartDate && (
                              <Tooltip title={t("toolTipClear")}>
                                <IconButton
                                  onClick={() =>
                                    handleValueChange("productionStartDate", "")
                                  }
                                  edge="end"
                                >
                                  <ClearIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                            {params.InputProps?.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>

            {sections.slice(0, 4).map(renderSection)}

            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  ...classes.label,
                  color: pillThemeConfig.LD.primaryColor,
                }}
              >
                <b>{t("trainerName")}</b>
              </Typography>
              <FormControl fullWidth>
                <Autocomplete
                  freeSolo
                  options={searchTrainerResults}
                  getOptionLabel={(option) => option.Display || ""}
                  onInputChange={handleTrainerInputChange}
                  onChange={handleTrainerSelect}
                  inputValue={classRosterDetails.trainerName || ""}
                  PopperComponent={CustomPopper}
                  open={
                    isTrainerAutocompleteOpen && searchTrainerResults.length > 0
                  }
                  onOpen={() => setIsTrainerAutocompleteOpen(true)}
                  onClose={() => setIsTrainerAutocompleteOpen(false)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      name="trainerName"
                      size="small"
                      variant="outlined"
                      sx={classes.formControl}
                      placeholder={t("inputTrainerName")}
                      value={classRosterDetails.trainerName || ""}
                      onChange={(event) =>
                        handleValueChange(event.target.name, event.target.value)
                      }
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          event.preventDefault();
                          if (
                            isTrainerAutocompleteOpen &&
                            searchTrainerResults.length > 0
                          ) {
                            return;
                          }
                          handleTrainerSearch(event, event.target.value);
                          setIsTrainerAutocompleteOpen(true);
                        }
                      }}
                      InputProps={{
                        maxLength: 50,
                        ...params.InputProps,
                        endAdornment: (
                          <InputAdornment position="end">
                            <CustomTooltip title={t("toolTipSearch")}>
                              <IconButton
                                id="icon-button-search"
                                type="button"
                                onClick={(event) =>
                                  handleTrainerSearch(
                                    event,
                                    classRosterDetails.trainerName,
                                  )
                                }
                              >
                                <SearchIcon />
                              </IconButton>
                            </CustomTooltip>
                            {params.InputProps.endAdornment}
                          </InputAdornment>
                        ),
                      }}
                    />
                  )}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                sx={{
                  ...classes.label,
                  color: pillThemeConfig.LD.primaryColor,
                }}
              >
                <b>{t("trainerEmail")}</b>
              </Typography>
              <TextField
                fullWidth
                name="trainerEmail"
                value={classRosterDetails.trainerEmail || ""}
                size="small"
                variant="outlined"
                sx={classes.formControl}
                placeholder={t("inputTrainerEmail")}
                onChange={(event) =>
                  handleValueChange(event.target.name, event.target.value)
                }
                InputProps={{ readOnly: true }}
              />
            </Grid>

            {type === "clone" ? (
              <>{sections.slice(4, 5).map(renderSection)}</>
            ) : (
              <>
                {sections.slice(4, 8).map(renderSection)}

                <Grid item xs={12}>
                  <Typography sx={classes.label}>
                    <b>{t("notes")}</b>
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    sx={classes.formControl}
                    variant="outlined"
                    size="small"
                    name="rosterNotes"
                    value={classRosterDetails.rosterNotes || ""}
                    rows={4}
                    placeholder={t("inputNotes")}
                    inputProps={{
                      maxLength: 4000,
                    }}
                    helperText={
                      <Box
                        component="span"
                        sx={{
                          color:
                            classRosterDetails.rosterNotes.length === 4000
                              ? "red"
                              : "inherit",
                        }}
                      >{`${
                        classRosterDetails.rosterNotes
                          ? classRosterDetails.rosterNotes.length
                          : 0
                      }/4000`}</Box>
                    }
                    FormHelperTextProps={{
                      sx: {
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                      },
                    }}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.value)
                    }
                  />
                </Grid>
              </>
            )}
          </Grid>

          <Divider orientation="vertical" flexItem sx={{ mx: 3 }} />

          {/* Right Section */}
          <Grid container spacing={2} flex="1">
            {type === "clone" ? (
              <>
                {sections.slice(5, 8).map(renderSection)}

                <Grid item xs={12}>
                  <Typography sx={classes.label}>
                    <b>{t("notes")}</b>
                  </Typography>
                  <TextField
                    fullWidth
                    multiline
                    sx={classes.formControl}
                    variant="outlined"
                    size="small"
                    name="rosterNotes"
                    value={classRosterDetails.rosterNotes || ""}
                    rows={4}
                    placeholder={t("inputNotes")}
                    inputProps={{
                      maxLength: 4000,
                    }}
                    helperText={
                      <Box
                        component="span"
                        sx={{
                          color:
                            classRosterDetails.rosterNotes.length === 4000
                              ? "red"
                              : "inherit",
                        }}
                      >{`${
                        classRosterDetails.rosterNotes
                          ? classRosterDetails.rosterNotes.length
                          : 0
                      }/4000`}</Box>
                    }
                    FormHelperTextProps={{
                      sx: {
                        position: "absolute",
                        bottom: 8,
                        right: 8,
                      },
                    }}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.value)
                    }
                  />
                </Grid>
              </>
            ) : (
              <Grid item xs={12}>
                {!(
                  classRosterDetails.productTrainingDateTime &&
                  classRosterDetails.productionStartDate &&
                  ((classRosterDetails.techEquipmentSolutionId !== 14 &&
                    (classRosterDetails.tciDateTime ||
                      classRosterDetails.techTestDateTime)) ||
                    (classRosterDetails.techEquipmentSolutionId === 14 &&
                      classRosterDetails.ttfDateTime))
                ) && (
                  <Box sx={classes.warningMessage01}>
                    <ErrorOutlineIcon
                      sx={{ marginRight: "5px", color: "#E23636" }}
                    />
                    <Typography>
                      {classRosterDetails.techEquipmentSolutionId !== 14
                        ? t("idmTicketWarning")
                        : t("idmTicketWarningTTF")}
                    </Typography>
                  </Box>
                )}

                <Typography sx={{ ...classes.label, color: "#7D71E2" }}>
                  <b>{t("newIDMTicket")}</b>
                </Typography>
                <Box
                  display="flex"
                  justifyContent="flex-start"
                  gap="8px"
                  alignItems="flex-start"
                  pb={2}
                >
                  <Grid item container xs={4} alignItems="center">
                    <FormControl
                      fullWidth
                      sx={classes.formControl}
                      error={!!errorMessage}
                    >
                      <TextField
                        name="idmTicket"
                        size="small"
                        placeholder={t("inputNewIDMTicket")}
                        value={idmTicketNumber || ""}
                        onChange={handleIDMTicketChange}
                        inputProps={{
                          maxLength: 11,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              {idmTicketNumber && (
                                <CustomTooltip title={t("toolTipClear")}>
                                  <IconButton
                                    onClick={() => setIDMTicketNumber("")}
                                    edge="end"
                                  >
                                    <ClearIcon />
                                  </IconButton>
                                </CustomTooltip>
                              )}
                              ,
                            </InputAdornment>
                          ),
                        }}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    container
                    xs={8}
                    justifyContent="flex-start"
                    alignItems="center"
                    gap="8px"
                  >
                    <CustomButton
                      variant="contained"
                      onClick={insertIDMTicketDetails}
                      sx={{ backgroundColor: "#3299FF" }}
                    >
                      {t("btnAddTicket")}
                    </CustomButton>
                    {classRosterDetails.productTrainingDateTime &&
                    classRosterDetails.productionStartDate &&
                    ((classRosterDetails.techEquipmentSolutionId !== 14 &&
                      (classRosterDetails.tciDateTime ||
                        classRosterDetails.techTestDateTime)) ||
                      (classRosterDetails.techEquipmentSolutionId === 14 &&
                        classRosterDetails.ttfDateTime)) ? (
                      <CustomButton
                        variant="contained"
                        sx={{ backgroundColor: "#3299FF" }}
                        onClick={handleCreateTicketClick}
                      >
                        {t("btnCreateTicket")}
                      </CustomButton>
                    ) : (
                      <CustomButton
                        variant="outlined"
                        sx={{ alignSelf: "flex-start" }}
                      >
                        {t("btnCreateTicket")}
                      </CustomButton>
                    )}
                    {showCreateIdmTickets && (
                      <CreateIdmTickets
                        rosterId={classRosterDetails.classRosterId}
                        classRequestId={classRosterDetails.classRequestId}
                        askNowTDT={classRosterDetails.askNowTDT}
                        ttfTrainerData={[
                          classRosterDetails.techEquipmentSolutionId === 14 &&
                          classRosterDetails.ttfDateTime
                            ? classRosterDetails.ttfDateTime
                            : null,
                          classRosterDetails.techEquipmentSolutionId !== 14 &&
                          classRosterDetails.tciDateTime
                            ? classRosterDetails.tciDateTime
                            : null,
                          classRosterDetails.techEquipmentSolutionId !== 14 &&
                          classRosterDetails.techTestDateTime
                            ? classRosterDetails.techTestDateTime
                            : null,
                          classRosterDetails.productionStartDate || null,
                          classRosterDetails.productTrainingDateTime || null,
                          classRosterDetails.trainerOracleId || null,
                          classRosterDetails.trainerName || "",
                          classRosterDetails.trainerEmail || "",
                          classRosterDetails.techEquipmentSolutionId === 14,
                        ]}
                        onClose={() => setShowCreateIdmTickets(false)}
                      />
                    )}
                  </Grid>
                </Box>

                <Typography sx={{ ...classes.label, color: "#7D71E2" }}>
                  <b>{t("idmTicketDetailsGrid")}</b>
                </Typography>
                <Box sx={{ display: "grid", overflow: "hidden" }}>
                  <Box sx={{ overflowX: "auto" }}>
                    <StyledDataGrid
                      autoHeight
                      rows={ticketRows}
                      columns={ticketColumns}
                      pageSize={ticketPageSize}
                      onPageSizeChange={(newPageSize) =>
                        setTicketPageSize(newPageSize)
                      }
                      rowsPerPageOptions={[5, 10, 25]}
                      disableSelectionOnClick
                      disableColumnMenu
                      sx={{ minWidth: 1000 }}
                      components={{
                        Footer: () => (
                          <CustomFooter
                            pageSize={ticketPageSize}
                            displayText={t("idmTicketGridFooter")}
                            rowCount={ticketRows.length}
                            rowsPerPageLabel={t("rowsPerPage")}
                          />
                        ),
                      }}
                    />
                  </Box>
                </Box>

                {!classRosterDetails.rosterLockDateTime && (
                  <Box sx={classes.warningMessage02}>
                    <ErrorOutlineIcon
                      sx={{ marginRight: "5px", color: "#E23636" }}
                    />
                    <Typography>{t("assignTraineeWarning")}</Typography>
                  </Box>
                )}

                <Grid
                  container
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{ mt: 2 }}
                >
                  <Grid item container xs={8} alignItems="center">
                    {classRosterDetails.assignTraineeLockDateTime && (
                      <Box sx={classes.warningMessage03}>
                        <ErrorOutlineIcon
                          sx={{ marginRight: "5px", color: "#E23636" }}
                        />
                        <Typography sx={{ fontWeight: "500" }}>
                          <b>{t("assignTraineeLocked")}</b>
                          <Box component="span" sx={{ fontWeight: "normal" }}>
                            &nbsp;&nbsp;
                            {moment(
                              classRosterDetails.assignTraineeLockDateTime,
                            ).format("DD-MM-YYYY hh:mm A")}
                          </Box>
                        </Typography>
                      </Box>
                    )}
                  </Grid>
                  <Grid
                    item
                    container
                    xs={4}
                    justifyContent="flex-end"
                    alignItems="center"
                  >
                    {classRosterDetails.rosterLockDateTime &&
                    !classRosterDetails.assignTraineeLockDateTime ? (
                      <CustomButton
                        variant="contained"
                        sx={{ backgroundColor: "#3299FF" }}
                        onClick={handleAssignTrainees}
                      >
                        {t("btnAssignTrainee")}
                      </CustomButton>
                    ) : (
                      <CustomButton variant="outlined">
                        {t("btnAssignTrainee")}
                      </CustomButton>
                    )}
                    {classRosterDetails.assignTraineeLockDateTime ? (
                      <CustomTooltip title={t("toolTipUnlock")}>
                        <IconButton
                          id="icon-button-toggle"
                          type="button"
                          onClick={() => handleRosterLock(false)}
                        >
                          <LockOutlinedIcon sx={classes.lockButton} />
                        </IconButton>
                      </CustomTooltip>
                    ) : (
                      <CustomTooltip title={t("toolTipLock")}>
                        <IconButton
                          id="icon-button-toggle"
                          type="button"
                          onClick={() => handleRosterLock(true)}
                        >
                          <LockOpenOutlinedIcon sx={classes.unLockButton} />
                        </IconButton>
                      </CustomTooltip>
                    )}
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Typography sx={classes.label}>
                    <b>{t("assignTraineeGrid")}</b>
                  </Typography>
                  <StyledDataGrid
                    autoHeight
                    rows={traineeRows}
                    columns={traineeColumns}
                    pageSize={traineePageSize}
                    onPageSizeChange={(newPageSize) =>
                      setTraineePageSize(newPageSize)
                    }
                    rowsPerPageOptions={[5, 10, 25]}
                    disableSelectionOnClick
                    disableColumnMenu
                    components={{
                      Footer: () => (
                        <CustomFooter
                          pageSize={traineePageSize}
                          displayText={t("assignTraineeGridFooter")}
                          rowCount={traineeRows.length}
                          rowsPerPageLabel={t("rowsPerPage")}
                        />
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            )}
          </Grid>
        </Box>
        <Box
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 10,
            backgroundColor: "background.paper",
            borderTop: "1px solid",
            borderColor: "divider",
            px: 2,
            py: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0px -2px 8px rgba(0,0,0,0.06)",
          }}
        >
          {/* Left — unsaved changes indicator */}
          <Typography
            sx={{
              fontSize: "12px",
              color: unsavedChanges ? "warning.main" : "text.disabled",
              fontStyle: "italic",
              transition: "color 0.2s",
            }}
          >
            {unsavedChanges
              ? t("unsavedChangesLabel", "You have unsaved changes")
              : ""}
          </Typography>

          {/* Right — action buttons */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            {/* Apply to all checkbox — edit mode only, moved here for proximity to Save */}
            {type === "edit" && (
              <FormControlLabel
                label={t("traineeUpdateOption")}
                control={
                  <Checkbox
                    name="applyUpdateToAll"
                    checked={classRosterDetails.applyUpdateToAll}
                    onChange={(event) =>
                      handleValueChange(event.target.name, event.target.checked)
                    }
                  />
                }
                sx={{
                  mr: 1,
                  "& .MuiFormControlLabel-label": {
                    fontWeight: "bold",
                    fontSize: "13px",
                  },
                }}
              />
            )}
            <CustomButton
              variant="contained"
              sx={{ backgroundColor: "#3299FF" }}
              onClick={handleSaveRosterConfigDetails}
            >
              {type === "clone" ? t("btnAdd") : t("btnEdit")}
            </CustomButton>
            <CustomButton variant="outlined" onClick={handleCancel}>
              {t("btnCancel")}
            </CustomButton>
          </Box>
        </Box>
      </Paper>
      <SnackBar snack={snack} snackReset={snackReset} />
    </>
  );
};

ConfigInputs.propTypes = {
  type: PropTypes.string.isRequired,
  classRosterId: PropTypes.string.isRequired,
  classRequestId: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
};

const RosterConfigInputs = ({ type, classRosterId, classRequestId, data }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryType = !type ? queryParams.get("type") : type;
  const queryClassRequestId = !classRequestId
    ? queryParams.get("classRequestId")
    : classRequestId;
  const queryClassRosterId = !classRosterId
    ? queryParams.get("classRosterId")
    : classRosterId;
  const queryData = !data ? queryParams.get("data") : data;

  return (
    <ThemeProvider theme={theme}>
      <ConfigInputs
        type={queryType}
        classRosterId={queryClassRosterId}
        classRequestId={queryClassRequestId}
        data={queryData}
      />
    </ThemeProvider>
  );
};

RosterConfigInputs.propTypes = {
  type: PropTypes.string,
  classRosterId: PropTypes.string,
  classRequestId: PropTypes.string,
  data: PropTypes.string,
};

export default RosterConfigInputs;
